{
  "about.blocks": "被本站限制的站点",
  "about.contact": "联系方式：",
  "about.default_locale": "默认",
  "about.disclaimer": "Mastodon 是自由的开源软件，是 Mastodon GmbH 的商标。",
  "about.domain_blocks.no_reason_available": "未提供原因",
  "about.domain_blocks.preamble": "一般而言，Mastodon 允许你查看联邦宇宙中任何站点上的内容并与之交互。以下是本站的例外规定。",
  "about.domain_blocks.silenced.explanation": "你在大多数情况下将不会看到来自此站点的账户和内容，除非你明确查找或通过关注该站点的用户来查看内容。",
  "about.domain_blocks.silenced.title": "已限制",
  "about.domain_blocks.suspended.explanation": "本站不会处理、存储或交换来自该站点的任何数据，因此无法与该站点上的用户进行任何交互或通信。",
  "about.domain_blocks.suspended.title": "已封禁",
  "about.language_label": "语言",
  "about.not_available": "此站点未提供该信息。",
  "about.powered_by": "由 {mastodon} 驱动的去中心化社交媒体",
  "about.rules": "站点规则",
  "account.account_note_header": "个人备注",
  "account.activity": "活动",
  "account.add_note": "添加个人备注",
  "account.add_or_remove_from_list": "加入或移出列表",
  "account.badges.admin": "管理员",
  "account.badges.blocked": "已屏蔽",
  "account.badges.bot": "无人值守",
  "account.badges.domain_blocked": "已屏蔽站点",
  "account.badges.group": "群组",
  "account.badges.muted": "已隐藏",
  "account.badges.muted_until": "隐藏至 {until}",
  "account.block": "屏蔽 @{name}",
  "account.block_domain": "屏蔽站点 {domain}",
  "account.block_short": "屏蔽",
  "account.blocked": "已屏蔽",
  "account.cancel_follow_request": "撤回关注请求",
  "account.copy": "复制账户页链接",
  "account.disable_notifications": "停止接收 @{name} 的发帖通知",
  "account.edit_note": "编辑个人备注",
  "account.edit_profile": "编辑个人资料",
  "account.edit_profile_short": "编辑",
  "account.enable_notifications": "当 @{name} 发帖时通知我",
  "account.endorse": "在账户页推荐",
  "account.familiar_followers_many": "{name1}、{name2}和{othersCount, plural, other {你认识的另外 # 个人}}关注了 Ta",
  "account.familiar_followers_one": "{name1}关注了 Ta",
  "account.familiar_followers_two": "{name1}和{name2}关注了 Ta",
  "account.featured": "推荐",
  "account.featured.accounts": "账户",
  "account.featured.collections": "合集",
  "account.featured.new_collection": "新建合集",
  "account.field_overflow": "显示完整内容",
  "account.filters.all": "所有活动",
  "account.filters.boosts_toggle": "显示转发",
  "account.filters.posts_boosts": "贴文与转发",
  "account.filters.posts_only": "贴文",
  "account.filters.posts_replies": "贴文与回复",
  "account.filters.replies_toggle": "显示回复",
  "account.follow": "关注",
  "account.follow_back": "回关",
  "account.follow_back_short": "回关",
  "account.follow_request": "请求关注",
  "account.follow_request_cancel": "取消请求",
  "account.follow_request_cancel_short": "取消",
  "account.follow_request_short": "请求",
  "account.followers": "粉丝",
  "account.followers.empty": "还没有人关注该用户。",
  "account.followers_counter": "{count, plural, other {{counter} 粉丝}}",
  "account.followers_you_know_counter": "你认识 {counter} 位",
  "account.following": "关注",
  "account.following_counter": "{count, plural, other {{counter} 关注}}",
  "account.follows.empty": "此用户尚未关注任何人。",
  "account.follows_you": "关注了你",
  "account.go_to_profile": "前往账户页",
  "account.hame.invalid_handle": "代号不可用",
  "account.in_memoriam": "谨此纪念。",
  "account.join_modal.day": "日",
  "account.join_modal.me": "你加入 {server} 的时间是",
  "account.join_modal.me_anniversary": "Fedi 周年日快乐！你加入 {server} 的时间是",
  "account.join_modal.me_today": "今天是你在 {server} 的第一天！",
  "account.join_modal.other": "{name} 加入 {server} 的时间是",
  "account.join_modal.other_today": "今天是 {name} 在 {server} 的第一天！",
  "account.join_modal.share.celebrate": "分享庆祝贴文",
  "account.join_modal.share.intro": "分享自我介绍贴文",
  "account.join_modal.share.welcome": "分享欢迎贴文",
  "account.join_modal.years": "{number, plural, other {年}}",
  "account.joined_short": "加入于",
  "account.languages": "更改订阅的语言",
  "account.last_active": "上次活跃",
  "account.link_verified_on": "此链接的所有权已于 {date} 验证",
  "account.locked_info": "此账户的隐私状态已设为锁定。账户所有者会手动审核关注申请。",
  "account.media": "媒体",
  "account.menu.add_to_collection": "添加到合集…",
  "account.menu.add_to_list": "添加到列表…",
  "account.menu.block": "屏蔽账户",
  "account.menu.block_domain": "屏蔽 {domain}",
  "account.menu.copied": "账户链接已复制到剪贴板",
  "account.menu.copy": "复制链接",
  "account.menu.direct": "私信",
  "account.menu.hide_reblogs": "在时间线中隐藏转发",
  "account.menu.mention": "提及",
  "account.menu.message": "私信",
  "account.menu.mute": "隐藏账户",
  "account.menu.note.description": "仅你可见",
  "account.menu.open_original_page": "在 {domain} 上查看",
  "account.menu.open_original_page_no_domain": "在原站点上查看",
  "account.menu.remove_follower": "移除粉丝",
  "account.menu.report": "举报账户",
  "account.menu.share": "分享…",
  "account.menu.show_reblogs": "在时间线上显示转发",
  "account.menu.unblock": "取消屏蔽",
  "account.menu.unblock_domain": "取消屏蔽 {domain}",
  "account.menu.unmute": "取消隐藏账户",
  "account.moved_to": "{name} 已迁移至：",
  "account.mute": "隐藏 @{name}",
  "account.mute_notifications_short": "静音通知",
  "account.mute_short": "隐藏",
  "account.muted": "已隐藏",
  "account.mutual": "你们正在相互关注",
  "account.name.copy": "复制代号",
  "account.name.help.domain": "{domain} 是托管此用户的账户和贴文的站点。",
  "account.name.help.domain_self": "{domain} 是托管你的账户和贴文的站点。",
  "account.name.help.footer": "你可以与其他 Mastodon 站点以及任何 Fediverse 站点上的用户进行互动，就像你可以使用不同的邮件提供商向他人发送邮件一样。",
  "account.name.help.header": "代号就像邮件地址一样",
  "account.name.help.invalid_explanation": "当用户更改用户名时可能会发生这种情况，这通常是暂时的。如果这种情况持续存在，可能是因为站点不可用或对方进行了某些错误配置。",
  "account.name.help.invalid_header": "此用户的代号正在更新",
  "account.name.help.username": "{username} 是该账户在其站点上的用户名。其他站点上的用户可能会有相同的用户名。",
  "account.name.help.username_self": "{username} 是你在本站的用户名。其他站点上的用户可能会有相同的用户名。",
  "account.name_info": "这是什么意思？",
  "account.no_bio": "未提供简介。",
  "account.node_modal.callout": "个人备注仅对你可见。",
  "account.node_modal.edit_title": "编辑个人备注",
  "account.node_modal.error_unknown": "无法保存备注",
  "account.node_modal.field_label": "个人备注",
  "account.node_modal.save": "保存",
  "account.node_modal.title": "添加个人备注",
  "account.note.edit_button": "编辑",
  "account.note.title": "个人备注（仅对你可见）",
  "account.open_original_page": "打开原始页面",
  "account.pending": "待审核",
  "account.posts": "贴文",
  "account.requested_follow": "{name} 请求关注你",
  "account.share": "分享 @{name} 的账户页",
  "account.statuses_counter": "{count, plural, other {{counter} 贴文}}",
  "account.timeline.pinned": "置顶",
  "account.timeline.pinned.view_all": "查看所有置顶贴文",
  "account.unblock": "解除屏蔽 @{name}",
  "account.unblock_domain": "解除屏蔽站点 {domain}",
  "account.unblock_domain_short": "解除屏蔽",
  "account.unblock_short": "解除屏蔽",
  "account.unendorse": "不在账户页推荐",
  "account.unfollow": "取关",
  "account.unmute": "取消隐藏 @{name}",
  "account.unmute_notifications_short": "取消通知静音",
  "account.unmute_short": "取消隐藏",
  "account_edit.advanced_settings.bot_hint": "向他人表明该账户主要执行无人值守操作，可能无人监控",
  "account_edit.advanced_settings.bot_label": "无人值守账户",
  "account_edit.advanced_settings.title": "高级设置",
  "account_edit.bio.add_label": "添加简介",
  "account_edit.bio.edit_label": "编辑简介",
  "account_edit.bio.placeholder": "添加一段简短的个人介绍，方便他人认识你。",
  "account_edit.bio.title": "简介",
  "account_edit.bio_modal.add_title": "添加简介",
  "account_edit.bio_modal.edit_title": "编辑简介",
  "account_edit.column_button": "已完成",
  "account_edit.column_title": "编辑个人资料",
  "account_edit.custom_fields.add_label": "添加字段",
  "account_edit.custom_fields.edit_label": "编辑字段",
  "account_edit.custom_fields.placeholder": "添加你的代词、外部链接或任何你想要分享的内容。",
  "account_edit.custom_fields.reorder_button": "将字段重新排序",
  "account_edit.custom_fields.tip_content": "通过验证指向你拥有的任何网站的链接，你可以轻松地为你的 Mastodon 账户增加可信度。",
  "account_edit.custom_fields.tip_title": "建议：添加已验证的链接",
  "account_edit.custom_fields.title": "自定义字段",
  "account_edit.custom_fields.verified_hint": "我该如何添加已验证链接？",
  "account_edit.display_name.add_label": "添加昵称",
  "account_edit.display_name.edit_label": "编辑昵称",
  "account_edit.display_name.placeholder": "你的昵称是你的名字在你的账户页以及时间线上显示的方式。",
  "account_edit.display_name.title": "昵称",
  "account_edit.featured_hashtags.edit_label": "添加话题",
  "account_edit.featured_hashtags.placeholder": "让他人认出并快速访问你最喜欢的主题。",
  "account_edit.featured_hashtags.title": "精选话题",
  "account_edit.field_actions.delete": "删除字段",
  "account_edit.field_actions.edit": "编辑字段",
  "account_edit.field_delete_modal.confirm": "你确定要删除此自定义字段吗？此操作无法撤销。",
  "account_edit.field_delete_modal.delete_button": "删除",
  "account_edit.field_delete_modal.title": "是否删除自定义字段？",
  "account_edit.field_edit_modal.add_title": "添加自定义字段",
  "account_edit.field_edit_modal.discard_confirm": "丢弃",
  "account_edit.field_edit_modal.discard_message": "你有未保存的更改。确定要丢弃这些更改吗？",
  "account_edit.field_edit_modal.edit_title": "编辑自定义字段",
  "account_edit.field_edit_modal.length_warning": "已超出建议的字符限制。移动端用户可能无法完整看到你的字段。",
  "account_edit.field_edit_modal.link_emoji_warning": "我们建议不要将自定义表情符号与 URL 一起使用。为了防止用户混淆，同时包含这两者的自定义字段将仅显示为文本，而不会显示为链接。",
  "account_edit.field_edit_modal.name_hint": "例如：“个人网站”",
  "account_edit.field_edit_modal.name_label": "字段名",
  "account_edit.field_edit_modal.url_warning": "要添加链接，请在开头包含 {protocol}。",
  "account_edit.field_edit_modal.value_hint": "例如：“https://example.me”",
  "account_edit.field_edit_modal.value_label": "字段值",
  "account_edit.field_reorder_modal.drag_cancel": "拖拽已取消。字段 “{item}” 已被放回。",
  "account_edit.field_reorder_modal.drag_end": "字段 “{item}” 已被放回。",
  "account_edit.field_reorder_modal.drag_instructions": "要重新排列自定义字段，请按空格键或回车键。拖动时，可使用方向键上下移动该字段。再次按下空格键或回车键可将其放置到新位置，或按 Esc 键取消。",
  "account_edit.field_reorder_modal.drag_move": "字段 “{item}” 已被移动。",
  "account_edit.field_reorder_modal.drag_over": "字段 “{item}” 已被移动到 “{over}” 上方。",
  "account_edit.field_reorder_modal.drag_start": "已选中字段 “{item}”。",
  "account_edit.field_reorder_modal.handle_label": "拖拽字段 “{item}”",
  "account_edit.field_reorder_modal.title": "调整字段顺序",
  "account_edit.image_alt_modal.add_title": "添加替代文本",
  "account_edit.image_alt_modal.details_content": "建议：<ul> <li>描述你在图中的形象</li> <li>使用第三人称（例如“Alex”，而不是“我”）</li> <li>保持简洁 —— 通常寥寥数语即可</li> </ul> 避免：<ul> <li>以“一张……的照片”开头 —— 这对屏幕阅读器来说是多余的</li> </ul> 示例：<ul> <li>“Alex 穿着一件绿衬衫，戴着眼镜”</li> </ul>",
  "account_edit.image_alt_modal.details_title": "提示：头像的替代文本",
  "account_edit.image_alt_modal.edit_title": "编辑替代文本",
  "account_edit.image_alt_modal.text_hint": "替代文本可帮助使用屏幕阅读器的用户理解你的内容。",
  "account_edit.image_alt_modal.text_label": "替代文本",
  "account_edit.image_delete_modal.confirm": "你确定要删除这张图片吗？此操作无法撤销。",
  "account_edit.image_delete_modal.delete_button": "删除",
  "account_edit.image_delete_modal.title": "确定删除图片？",
  "account_edit.image_edit.add_button": "添加图片",
  "account_edit.image_edit.alt_add_button": "添加替代文本",
  "account_edit.image_edit.alt_edit_button": "编辑替代文本",
  "account_edit.image_edit.remove_button": "移除图片",
  "account_edit.image_edit.replace_button": "替换图片",
  "account_edit.item_list.delete": "删除 {name}",
  "account_edit.item_list.edit": "编辑 {name}",
  "account_edit.name_modal.add_title": "添加昵称",
  "account_edit.name_modal.edit_title": "编辑昵称",
  "account_edit.profile_tab.button_label": "自定义",
  "account_edit.profile_tab.hint.description": "这些设置可自定义用户在官方应用中看到的 {server} 上的内容，但它们可能不适用于其他站点和第三方应用的用户。",
  "account_edit.profile_tab.hint.title": "显示效果仍将存在差异",
  "account_edit.profile_tab.show_featured.description": "“精选”是一个可选选项卡，你可以在这里展示其他账户。",
  "account_edit.profile_tab.show_featured.title": "显示“精选”选项卡",
  "account_edit.profile_tab.show_media.description": "“媒体”是一个可选选项卡，用于显示你发布的包含图片或视频的贴文。",
  "account_edit.profile_tab.show_media.title": "展示“媒体”选项卡",
  "account_edit.profile_tab.show_media_replies.description": "开启后，媒体选项卡将同时显示你的贴文以及对他人贴文的回复。",
  "account_edit.profile_tab.show_media_replies.title": "在“媒体”选项卡中包含回复",
  "account_edit.profile_tab.show_relations.description": "在你的账户页中向其他用户展示你关注的账户和粉丝。其他人仍然可以看到你是否在关注他们。",
  "account_edit.profile_tab.show_relations.title": "显示“粉丝”和“关注”",
  "account_edit.profile_tab.subtitle": "自定义你的账户页显示方式。",
  "account_edit.profile_tab.title": "账户页显示设置",
  "account_edit.save": "保存",
  "account_edit.upload_modal.back": "返回",
  "account_edit.upload_modal.done": "已完成",
  "account_edit.upload_modal.next": "下一步",
  "account_edit.upload_modal.step_crop.zoom": "缩放",
  "account_edit.upload_modal.step_upload.button": "浏览文件",
  "account_edit.upload_modal.step_upload.dragging": "拖拽到此处松开以上传",
  "account_edit.upload_modal.step_upload.header": "选择图片",
  "account_edit.upload_modal.step_upload.hint": "支持 WEBP、PNG、GIF 或 JPG 格式，大小不超过 {limit}MB。{br}图片将被缩放至 {width}x{height}px。",
  "account_edit.upload_modal.title_add.avatar": "添加头像",
  "account_edit.upload_modal.title_add.header": "添加封面背景图",
  "account_edit.upload_modal.title_replace.avatar": "更换头像",
  "account_edit.upload_modal.title_replace.header": "更换封面背景图",
  "account_edit.verified_modal.details": "你可以通过验证指向个人网站的链接为你的 Mastodon 账户页增加可信度。以下是它的运作方式：",
  "account_edit.verified_modal.invisible_link.details": "将链接添加到你的页面头部。关键在于 rel=\"me\"，它可以防止在有用户生成内容的网站上发生身份冒用。你甚至可以在页面头部使用 link 标签来代替 {tag}，但 HTML 必须在不执行 JavaScript 的情况下也能被访问。",
  "account_edit.verified_modal.invisible_link.summary": "如何让链接不可见？",
  "account_edit.verified_modal.step1.header": "复制下方的 HTML 代码并粘贴到你的网站头部",
  "account_edit.verified_modal.step2.details": "如果你已经将你的网站添加到了自定义字段，你将需要将其删除并重新添加，以触发验证。",
  "account_edit.verified_modal.step2.header": "将你的网站添加为自定义字段",
  "account_edit.verified_modal.title": "如何添加已验证链接",
  "account_edit_tags.add_tag": "添加 #{tagName}",
  "account_edit_tags.column_title": "编辑话题",
  "account_edit_tags.help_text": "精选话题有助于用户发现你的账户页并与之互动。它们会作为过滤规则出现在你的账户页动态视图中。",
  "account_edit_tags.max_tags_reached": "你添加的精选话题数量已达上限。",
  "account_edit_tags.search_placeholder": "输入话题…",
  "account_edit_tags.suggestions": "建议：",
  "account_edit_tags.tag_status_count": "{count, plural, other {# 条贴文}}",
  "account_list.hidden_notice": "这只有你可见。要向其他人展示此列表，请前往 <link>{page} > {modal} > {field}</link>。",
  "account_list.total": "{total, plural, other {# 个账户}}",
  "admin.dashboard.daily_retention": "用户注册后留存率（按天计算）",
  "admin.dashboard.monthly_retention": "用户注册后留存率（按月计算）",
  "admin.dashboard.retention.average": "平均值",
  "admin.dashboard.retention.cohort": "注册月份",
  "admin.dashboard.retention.cohort_size": "新用户",
  "admin.impact_report.instance_accounts": "此操作将删除的账户",
  "admin.impact_report.instance_followers": "本站用户将失去的粉丝",
  "admin.impact_report.instance_follows": "对方站点的用户将失去的粉丝",
  "admin.impact_report.title": "影响摘要",
  "alert.need_reload.message": "Mastodon 已更新。在你重新加载页面之前，某些功能可能无法正常工作。",
  "alert.rate_limited.message": "请在 {retry_time, time, medium} 后重试。",
  "alert.rate_limited.title": "已达到速率限制",
  "alert.unexpected.message": "发生意外错误。",
  "alert.unexpected.title": "啊哦！",
  "alt_text_badge.title": "替代文本",
  "alt_text_modal.add_alt_text": "添加替代文本",
  "alt_text_modal.add_text_from_image": "添加图片中的文本",
  "alt_text_modal.cancel": "取消",
  "alt_text_modal.change_thumbnail": "更改缩略图",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "为听障人士描述此内容…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "为视障人士描述此内容…",
  "alt_text_modal.done": "完成",
  "announcement.announcement": "公告",
  "annual_report.announcement.action_build": "生成我的 Wrapstodon 年度回顾",
  "annual_report.announcement.action_dismiss": "不用了",
  "annual_report.announcement.action_view": "查看我的 Wrapstodon 年度回顾",
  "annual_report.announcement.description": "探索过去一年中你在 Mastodon 上的活跃情况。",
  "annual_report.announcement.title": "Wrapstodon {year} 年度回顾已开启",
  "annual_report.nav_item.badge": "新",
  "annual_report.shared_page.donate": "捐赠",
  "annual_report.shared_page.footer": "由 Mastodon 团队倾情制作 {heart}",
  "annual_report.shared_page.footer_server_info": "{username} 使用的是 {domain}，这是由 Mastodon 驱动的众多社区之一。",
  "annual_report.summary.archetype.booster.desc_public": "{name} 乐于转发贴文，精准地为其他创作者扩大影响力。",
  "annual_report.summary.archetype.booster.desc_self": "你乐于转发贴文，精准地为其他创作者扩大影响力。",
  "annual_report.summary.archetype.booster.name": "贴文射手",
  "annual_report.summary.archetype.die_drei_fragezeichen": "???",
  "annual_report.summary.archetype.lurker.desc_public": "我们知道 {name} 就在某个地方，正以自己的方式安静地享受着 Mastodon。",
  "annual_report.summary.archetype.lurker.desc_self": "我们知道你就在某处，正以自己的方式安静地享受着 Mastodon。",
  "annual_report.summary.archetype.lurker.name": "围观群众",
  "annual_report.summary.archetype.oracle.desc_public": "{name} 发布新贴文的次数多于回复，让 Mastodon 保持新鲜感且面向未来。",
  "annual_report.summary.archetype.oracle.desc_self": "你发布新贴文的次数多于回复，让 Mastodon 保持新鲜感且面向未来。",
  "annual_report.summary.archetype.oracle.name": "贴文先锋",
  "annual_report.summary.archetype.pollster.desc_public": "{name} 发起的投票多于其他贴文类型，在 Mastodon 上激发了大家的好奇心。",
  "annual_report.summary.archetype.pollster.desc_self": "你发起的投票多于其他贴文类型，在 Mastodon 上激发了大家的好奇心。",
  "annual_report.summary.archetype.pollster.name": "投票专家",
  "annual_report.summary.archetype.replier.desc_public": "{name} 频繁回复他人的贴文，在 Mastodon 上播撒新的讨论。",
  "annual_report.summary.archetype.replier.desc_self": "你频繁回复他人的贴文，在 Mastodon 上播撒新的讨论。",
  "annual_report.summary.archetype.replier.name": "评论区原住民",
  "annual_report.summary.archetype.reveal": "揭晓我的人设",
  "annual_report.summary.archetype.reveal_description": "感谢你成为 Mastodon 的一员！是时候看看你在 {year} 年代表了哪种人设了。",
  "annual_report.summary.archetype.title_public": "{name} 的人设",
  "annual_report.summary.archetype.title_self": "你的人设",
  "annual_report.summary.close": "关闭",
  "annual_report.summary.copy_link": "复制链接",
  "annual_report.summary.followers.new_followers": "{count, plural, other {位新粉丝}}",
  "annual_report.summary.highlighted_post.boost_count": "此贴文已被转发 {count, plural, other {# 次}}。",
  "annual_report.summary.highlighted_post.favourite_count": "此贴文已被点赞 {count, plural, other {# 次}}。",
  "annual_report.summary.highlighted_post.reply_count": "此贴文收到了 {count, plural, other {# 条回复}}。",
  "annual_report.summary.highlighted_post.title": "最受欢迎贴文",
  "annual_report.summary.most_used_app.most_used_app": "最常用的应用",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "最常用的话题",
  "annual_report.summary.most_used_hashtag.used_count": "你在 {count, plural, other {# 个贴文}}中使用了此话题。",
  "annual_report.summary.most_used_hashtag.used_count_public": "{name} 在 {count, plural, other {# 个贴文}}中使用了此话题。",
  "annual_report.summary.new_posts.new_posts": "新贴文",
  "annual_report.summary.percentile.text": "<topLabel>这使你跻身 {domain} 用户的前</topLabel><percentage></percentage><bottomLabel></bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": " ",
  "annual_report.summary.share_elsewhere": "分享到其他地方",
  "annual_report.summary.share_message": "我的人设是 {archetype}！",
  "annual_report.summary.share_on_mastodon": "分享到 Mastodon",
  "attachments_list.unprocessed": "（未处理）",
  "audio.hide": "隐藏音频",
  "block_modal.no_collections": "你们双方都无法将对方添加到合集。如果适用，你将被自动从对方现有的合集中移除。",
  "block_modal.remote_users_caveat": "我们将要求 {domain} 站点尊重你的决定。但是，我们无法保证对方站点一定会遵守，因为某些站点可能会以不同的方式处理屏蔽。未登录的用户可能仍然可以看到公开的贴文。",
  "block_modal.show_less": "折叠",
  "block_modal.show_more": "展开",
  "block_modal.they_cant_mention": "你们无法互相提及、关注或引用。",
  "block_modal.they_cant_see_posts": "对方将无法看到你的内容，你也将无法看到对方的内容。",
  "block_modal.they_will_know": "对方会知道自己被屏蔽了。",
  "block_modal.title": "是否屏蔽该用户？",
  "block_modal.you_wont_see_mentions": "你将不会看到其他人提及他们的贴文。",
  "boost_modal.combo": "下次可按 {combo} 跳过此对话框",
  "boost_modal.reblog": "是否转发贴文？",
  "boost_modal.undo_reblog": "是否取消转发？",
  "bundle_column_error.copy_stacktrace": "复制错误报告",
  "bundle_column_error.error.body": "无法渲染所请求的页面。这可能是由于我们的代码中存在错误，或是浏览器兼容性问题。",
  "bundle_column_error.error.title": "哦不！",
  "bundle_column_error.network.body": "尝试加载此页面时出错。这可能是因为你的网络出现故障或此站点出现临时问题。",
  "bundle_column_error.network.title": "网络错误",
  "bundle_column_error.retry": "重试",
  "bundle_column_error.return": "返回主页",
  "bundle_column_error.routing.body": "找不到此页面。你确定地址栏中的 URL 正确吗？",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "关闭",
  "bundle_modal_error.message": "加载此界面时出错。",
  "bundle_modal_error.retry": "重试",
  "callout.dismiss": "关闭",
  "card.delete": "移除此项",
  "carousel.current": "第 {current, number} / {max, number} <sr>条</sr>",
  "carousel.slide": "第 {current, number} / {max, number} 张幻灯片",
  "character_counter.recommended": "{currentLength}/{maxLength} 字符（建议）",
  "character_counter.required": "{currentLength}/{maxLength} 字符",
  "closed_registrations.other_server_instructions": "Mastodon 是去中心化的，你可以在另一台站点上创建账户，并且仍然可以与此站点互动。",
  "closed_registrations_modal.description": "目前无法在 {domain} 上创建账户，但你可能想要了解的是，你不需要专门在 {domain} 上拥有账户即可使用 Mastodon。",
  "closed_registrations_modal.find_another_server": "查找其它站点",
  "closed_registrations_modal.preamble": "Mastodon 是去中心化的，无论你在哪里创建账户，你都可以关注此站点上的任何人并与之互动。你甚至可以自己托管它！",
  "closed_registrations_modal.title": "注册 Mastodon",
  "collection.share_modal.share_link_label": "分享链接",
  "collection.share_modal.share_via_post": "在 Mastodon 上发帖",
  "collection.share_modal.share_via_system": "分享到…",
  "collection.share_modal.title": "分享合集",
  "collection.share_modal.title_new": "分享你的新合集！",
  "collection.share_template_other": "看看这个合集：",
  "collection.share_template_own": "看看我的新合集：",
  "collections.account_count": "{count, plural, other {# 个账户}}",
  "collections.accounts.empty_description": "添加最多 {count} 个账户",
  "collections.accounts.empty_editor_title": "此合集中暂无任何人",
  "collections.accounts.empty_title": "此合集为空",
  "collections.add_to_collection": "将 {name} 添加到合集",
  "collections.block_collection_owner": "屏蔽账户",
  "collections.by_account": "来自 {account_handle}",
  "collections.collection_description": "描述",
  "collections.collection_language": "语言",
  "collections.collection_language_none": "无",
  "collections.collection_name": "名称",
  "collections.collection_topic": "主题",
  "collections.confirm_account_removal": "你确定要从此合集中移除该账户吗？",
  "collections.content_warning": "内容警告",
  "collections.continue": "继续",
  "collections.copy_link": "复制链接",
  "collections.copy_link_confirmation": "已复制合集链接到剪贴板",
  "collections.create.accounts_title": "你要把谁加入此合集呢？",
  "collections.create.basic_details_title": "基础信息",
  "collections.create.steps": "第 {step}/{total} 步",
  "collections.create_collection": "创建合集",
  "collections.create_new_collection": "创建新合集",
  "collections.delete_collection": "删除合集",
  "collections.description_length_hint": "最多 100 个字符",
  "collections.detail.author_added_you_on_date": "{author} 在 {date} 把你添加到了合集",
  "collections.detail.loading": "合集加载中…",
  "collections.detail.revoke_inclusion": "将我移除",
  "collections.detail.sensitive_content": "敏感内容",
  "collections.detail.sensitive_note": "该简介和账户可能不适合所有观众观看。",
  "collections.detail.share": "分享此合集",
  "collections.detail.you_are_in_this_collection": "你被收录在这个合集中",
  "collections.edit_details": "修改详细信息",
  "collections.error_loading_collections": "加载这些合集时出错。",
  "collections.hidden_accounts_description": "你已屏蔽或隐藏 {count, plural, other {这些用户}}",
  "collections.hidden_accounts_link": "{count, plural, other {# 个隐藏账户}}",
  "collections.hints.accounts_counter": "{count}/{max} 个账户",
  "collections.last_updated_at": "上次编辑于：{date}",
  "collections.list.collections_with_count": "{count, plural, other {# 个合集}}",
  "collections.list.created_by_author": "由 {name} 创建",
  "collections.list.created_by_you": "由你创建",
  "collections.list.featuring_you": "收录了你",
  "collections.manage_accounts": "管理账户",
  "collections.mark_as_sensitive": "设为敏感",
  "collections.mark_as_sensitive_hint": "将合集的描述与合集中的账户隐藏在内容警告之后。合集名称仍将可见。",
  "collections.maximum_collection_count_description": "你的站点允许创建最多 {count} 个合集。",
  "collections.maximum_collection_count_reached": "你已达到合集数量上限",
  "collections.name_length_hint": "最多 40 个字符",
  "collections.new_collection": "新建合集",
  "collections.pending_accounts.message": "当我们等待用户或其站点的响应时，账户可能会显示为待审核。只有你可见待审核账户。",
  "collections.pending_accounts.title": "为什么我看到了待审核账户？",
  "collections.remove_account": "移除",
  "collections.report_collection": "举报此合集",
  "collections.revoke_collection_inclusion": "将我从此合集中移除",
  "collections.revoke_inclusion.confirmation": "你被从合集“{collection}”中移除",
  "collections.revoke_inclusion.error": "出现错误，请稍后再试。",
  "collections.search_accounts_label": "搜索要添加的账户",
  "collections.search_accounts_max_reached": "你添加的账户数量已达上限",
  "collections.sensitive": "敏感",
  "collections.share_short": "分享",
  "collections.sort_alphabetical": "按字母顺序",
  "collections.sort_by": "排序方式：",
  "collections.sort_date_added": "添加日期",
  "collections.sort_last_active": "上次活跃",
  "collections.sort_most_followers": "最多粉丝",
  "collections.suggestions.can_not_add": "无法添加",
  "collections.suggestions.can_not_add_desc": "这些账户可能已选择退出发现，或者它们所在的站点不支持合集。",
  "collections.suggestions.must_follow": "必须先关注",
  "collections.suggestions.must_follow_desc": "这些账户会审核所有关注请求。粉丝可以将它们添加到合集。",
  "collections.topic_hint": "添加一个话题，帮助他人理解此合集的主题。",
  "collections.topic_special_chars_hint": "保存时将删除特殊字符",
  "collections.unlisted_collections_description": "这些不会在你的账户页上向其他人展示。任何拥有链接的人都可以发现它们。",
  "collections.unlisted_collections_with_count": "未列出的合集 ({count})",
  "collections.view_collection": "查看合集",
  "collections.visibility_public": "公开",
  "collections.visibility_public_hint": "可在搜索结果及其他展示推荐内容的区域被发现。",
  "collections.visibility_title": "可见性",
  "collections.visibility_unlisted": "半公开",
  "collections.visibility_unlisted_hint": "对拥有链接的任何人可见。从搜索结果和推荐中隐藏。",
  "column.about": "关于",
  "column.blocked_accounts": "已屏蔽的账户",
  "column.blocks": "已屏蔽用户",
  "column.bookmarks": "收藏夹",
  "column.community": "本站时间线",
  "column.create_custom_feed": "创建自定义动态",
  "column.create_list": "创建列表",
  "column.custom_feeds": "自定义动态",
  "column.direct": "私信",
  "column.directory": "浏览账户",
  "column.domain_blocks": "已屏蔽的站点",
  "column.edit_custom_feed": "编辑自定义动态",
  "column.edit_list": "编辑列表",
  "column.favourites": "点赞",
  "column.firehose": "动态",
  "column.firehose_local": "本站实时动态",
  "column.firehose_singular": "实时动态",
  "column.follow_requests": "关注请求",
  "column.following": "关注",
  "column.following_settings": "关注动态设置",
  "column.has_unread_content": "(有未读内容)",
  "column.home": "主页",
  "column.list_members": "管理列表成员",
  "column.lists": "列表",
  "column.mutes": "已隐藏的用户",
  "column.notifications": "通知",
  "column.other_collections": "{name} 创建的合集",
  "column.other_servers": "其他站点",
  "column.pins": "置顶贴文",
  "column.public": "跨站时间线",
  "column.saved_posts": "已保存的贴文",
  "column.settings": "栏目设置",
  "column.this_server": "本站",
  "column.your_collections": "你的合集",
  "column_back_button.label": "返回",
  "column_header.hide_settings": "隐藏设置",
  "column_header.moveLeft_settings": "将此栏左移",
  "column_header.moveRight_settings": "将此栏右移",
  "column_header.move_column_left": "将此栏左移",
  "column_header.move_column_right": "将此栏右移",
  "column_header.pin": "置顶",
  "column_header.pin_column": "固定栏",
  "column_header.show_settings": "显示设置",
  "column_header.unpin": "取消置顶",
  "column_header.unpin_column": "取消固定栏",
  "column_search.cancel": "取消",
  "combobox.close_results": "关闭结果",
  "combobox.loading": "加载中",
  "combobox.no_results_found": "没有搜索到结果",
  "combobox.open_results": "打开结果",
  "combobox.results_available": "{count, plural, other {有 # 条建议}}可用。使用上下方向键进行导航。按回车键进行选择。",
  "community.column_settings.local_only": "仅本站",
  "community.column_settings.media_only": "仅媒体",
  "community.column_settings.remote_only": "仅外站",
  "compose.cancel_modal.body": "你有一个正在进行的草稿。你想做什么？",
  "compose.cancel_modal.continue": "继续草稿",
  "compose.cancel_modal.delete": "删除草稿",
  "compose.cancel_modal.title": "丢弃草稿",
  "compose.counter": "{current, number}/{max, number}",
  "compose.discoverable": "可在公共时间线和搜索结果中被发现",
  "compose.error.blank_post": "贴文内容不能为空。",
  "compose.expand": "显示编辑器",
  "compose.hints.followers-reply": "你正在回复一条仅限粉丝可见的贴文。未关注 {user} 的人可能会看到你的回复，而无法看到你正在回复的上下文。",
  "compose.hints.language": "将此贴文的语言更改为 {language}？",
  "compose.hints.language.change": "更改",
  "compose.hints.language.dismiss": "关闭",
  "compose.hints.missing-alt": "你的附件缺少替代文本。",
  "compose.hints.missing-alt-many": "你的一个或多个附件缺少替代文本。",
  "compose.language.change": "更改语言",
  "compose.language.not-found": "未找到语言",
  "compose.language.search": "搜索语言...",
  "compose.message.direct.followers": "{name} {count, plural, =0 {} other {+ # 其他人}}",
  "compose.message.notice": "私信未进行端到端加密",
  "compose.message.placeholder": "添加收件人和你的私信。",
  "compose.message.publish": "发送",
  "compose.minimize": "最小化编辑器",
  "compose.new": "编写新贴文或私信",
  "compose.new.message": "私信",
  "compose.new.post": "贴文",
  "compose.poll.add": "添加另一个选项",
  "compose.poll.delete": "删除投票",
  "compose.poll.duration": "持续时间：",
  "compose.poll.multiple": "允许多选",
  "compose.post.placeholder": "你想说些什么？",
  "compose.post.privacy.followers": "粉丝 {count, plural, =0 {} other {+ # 其他人}}",
  "compose.post.title.edit": "编辑贴文",
  "compose.post.title.new": "新贴文",
  "compose.post.to": "发送给：",
  "compose.post.to_message": "改写私信",
  "compose.publish": "发布",
  "compose.published.body": "贴文已发布。",
  "compose.published.open": "打开",
  "compose.quotable": "允许他人引用",
  "compose.quote.audio": "音频文件 {duration}",
  "compose.quote.poll": "投票 {sep} {isOpen, select, open {接受回应} other {已关闭}}",
  "compose.quote.spoiler": "内容：",
  "compose.rearrange_modal.cancel": "取消",
  "compose.rearrange_modal.drag_cancel": "拖动已取消。媒体附件 {item, number} 已丢弃。",
  "compose.rearrange_modal.drag_end": "附件索引 {item, number} 已移动到索引 {over, number}。",
  "compose.rearrange_modal.drag_instructions": "要重新排列附件，请按空格键或回车键。拖动时，可使用方向键上下移动附件。再次按下空格键或回车键可将其放到新位置，或按 Esc 键取消。",
  "compose.rearrange_modal.drag_move": "附件索引 {item, number} 已移动。",
  "compose.rearrange_modal.drag_over": "附件索引 {item, number} 已移动到索引 {over, number} 上方。",
  "compose.rearrange_modal.drag_start": "已拾起索引为 {item, number} 的附件。",
  "compose.rearrange_modal.handle": "拖动位置 {index, number} 处的附件",
  "compose.rearrange_modal.save": "保存",
  "compose.rearrange_modal.title": "重新排列媒体",
  "compose.reply.title.new": "新回复",
  "compose.saved.body": "贴文已保存。",
  "compose.sensitive": "敏感",
  "compose.sensitive.text": "敏感内容描述",
  "compose.switch_modal.back": "返回",
  "compose.switch_modal.body": "你的私信可见性受限。如果你将其转换为贴文，它将切换为你的默认贴文可见性。",
  "compose.switch_modal.continue": "继续",
  "compose.switch_modal.title": "转换为贴文？",
  "compose.upload.alt": "替代文本",
  "compose.upload.audio.delete": "移除音频",
  "compose.upload.menu": "添加替代文本或移除图片",
  "compose.upload.menu.add_alt": "添加替代文本",
  "compose.upload.menu.delete": "移除图片",
  "compose.upload.menu.edit_alt": "编辑替代文本",
  "compose.upload.menu.rearrange": "重新排列…",
  "compose.visibility.direct_note": "提及的所有人",
  "compose.visibility.quote_policy": "引用范围",
  "compose.visibility.quote_policy.anyone": "任何人",
  "compose.visibility.quote_policy.followers": "粉丝",
  "compose.visibility.title": "可见性",
  "compose.visibility.to_post": "改为撰写贴文",
  "compose_form.direct_message_warning_learn_more": "了解更多",
  "compose_form.encryption_warning": "Mastodon 上的贴文并未进行端到端加密。请勿通过 Mastodon 分享任何敏感信息。",
  "compose_form.hashtag_warning": "此贴文不是公开贴文，所以不会被包含在任何话题下。只有公开的贴文才能通过话题被搜索到。",
  "compose_form.lock_disclaimer": "你的账户未{locked}。任何人都可以关注你以查看你设置“仅粉丝可见”的贴文。",
  "compose_form.lock_disclaimer.lock": "锁定",
  "compose_form.message.title.edit": "编辑私信",
  "compose_form.message.title.new": "新私信",
  "compose_form.placeholder": "在想什么呢？",
  "compose_form.poll.duration": "投票时长",
  "compose_form.poll.multiple": "多选",
  "compose_form.poll.option_placeholder": "选项 {number}",
  "compose_form.poll.single": "单选",
  "compose_form.poll.switch_to_multiple": "将投票改为允许多选",
  "compose_form.poll.switch_to_single": "将投票改为仅单选",
  "compose_form.poll.type": "类型",
  "compose_form.publish": "发布",
  "compose_form.reply": "回复",
  "compose_form.reply.title.edit": "编辑回复",
  "compose_form.save_changes": "更新",
  "compose_form.spoiler.marked": "移除内容警告",
  "compose_form.spoiler.unmarked": "添加内容警告",
  "compose_form.spoiler_placeholder": "内容警告（可选）",
  "confirmation_modal.cancel": "取消",
  "confirmations.block.confirm": "屏蔽",
  "confirmations.delete.confirm": "删除",
  "confirmations.delete.message": "你确定要删除此贴文吗？",
  "confirmations.delete.title": "确认删除贴文？",
  "confirmations.delete_collection.confirm": "删除",
  "confirmations.delete_collection.message": "此操作无法撤销。",
  "confirmations.delete_collection.title": "是否删除“{name}”？",
  "confirmations.delete_list.confirm": "删除",
  "confirmations.delete_list.message": "你确定要永久删除此列表吗？",
  "confirmations.delete_list.title": "确认删除列表？",
  "confirmations.discard_draft.confirm": "撤销并继续",
  "confirmations.discard_draft.edit.cancel": "继续编辑",
  "confirmations.discard_draft.edit.message": "继续操作将撤销你对当前正在编辑的贴文所做的任何更改。",
  "confirmations.discard_draft.edit.title": "撤销对贴文的更改？",
  "confirmations.discard_draft.post.cancel": "继续编辑草稿",
  "confirmations.discard_draft.post.message": "继续操作将丢弃你当前正在撰写的贴文。",
  "confirmations.discard_draft.post.title": "是否丢弃贴文草稿？",
  "confirmations.discard_edit_media.confirm": "丢弃",
  "confirmations.discard_edit_media.message": "你对媒体描述或预览有未保存的更改，仍要舍弃吗？",
  "confirmations.follow_to_list.confirm": "关注并添加到列表",
  "confirmations.follow_to_list.message": "你需要先关注 {name} 才能将其添加到列表。",
  "confirmations.follow_to_list.title": "确认关注此用户？",
  "confirmations.hide_featured_tab.confirm": "隐藏选项卡",
  "confirmations.hide_featured_tab.intro": "你随时可以在<i>编辑个人资料 > 账户页选项卡设置</i>下更改此设置。",
  "confirmations.hide_featured_tab.message": "这将在运行最新版本 Mastodon 的站点（ {serverName} 和其他站点）上为用户隐藏该选项卡。其它站点展示方式可能会有所不同。",
  "confirmations.hide_featured_tab.title": "隐藏“精选”选项卡？",
  "confirmations.logout.confirm": "登出",
  "confirmations.logout.message": "你确定要退出登录吗？",
  "confirmations.logout.title": "确认退出登录？",
  "confirmations.missing_alt_text.confirm": "添加替代文本",
  "confirmations.missing_alt_text.message": "你的贴文包含没有替代文本的媒体。添加描述可以让更多人能够访问你的内容。",
  "confirmations.missing_alt_text.secondary": "仍然发布",
  "confirmations.missing_alt_text.title": "是否添加替代文本？",
  "confirmations.mute.confirm": "隐藏",
  "confirmations.private_quote_notify.cancel": "返回编辑",
  "confirmations.private_quote_notify.confirm": "发布贴文",
  "confirmations.private_quote_notify.do_not_show_again": "不再显示此消息",
  "confirmations.private_quote_notify.message": "你所引用与提及的用户将收到通知且能够查看你的贴文，即便这些用户没有关注你。",
  "confirmations.private_quote_notify.title": "是否和粉丝和提及的用户分享此内容？",
  "confirmations.quiet_post_quote_info.dismiss": "不再提醒",
  "confirmations.quiet_post_quote_info.got_it": "明白了",
  "confirmations.quiet_post_quote_info.message": "当引用可见性为“半公开”的贴文时，你的贴文不会出现在热门中。",
  "confirmations.quiet_post_quote_info.title": "引用半公开的贴文",
  "confirmations.redraft.confirm": "删除并重新编辑",
  "confirmations.redraft.message": "你确定要删除此贴文并重新编辑吗？点赞和转发将会丢失，对原始贴文的回复将成为孤立回复。",
  "confirmations.redraft.title": "是否删除并重新编辑贴文？",
  "confirmations.remove_from_followers.confirm": "移除粉丝",
  "confirmations.remove_from_followers.message": "{name} 将不再关注你。你确定要继续吗？",
  "confirmations.remove_from_followers.title": "确认移除粉丝？",
  "confirmations.revoke_collection_inclusion.confirm": "将我移除",
  "confirmations.revoke_collection_inclusion.message": "整理者在接下来的 24 小时内无法将你重新添加到此合集。要永久阻止他们将你添加到合集，你可以屏蔽他们。",
  "confirmations.revoke_collection_inclusion.title": "是否将你自己从此合集中移除？",
  "confirmations.revoke_quote.confirm": "移除贴文",
  "confirmations.revoke_quote.message": "此操作无法撤销。",
  "confirmations.revoke_quote.title": "移除贴文？",
  "confirmations.unblock.confirm": "解除屏蔽",
  "confirmations.unblock.title": "取消屏蔽 {name} 吗？",
  "confirmations.unfollow.confirm": "取关",
  "confirmations.unfollow.title": "取关 {name} 吗？",
  "confirmations.withdraw_request.confirm": "撤回请求",
  "confirmations.withdraw_request.title": "撤回关注 {name} 的请求吗？",
  "content_warning.hide": "隐藏贴文",
  "content_warning.show": "仍然显示",
  "content_warning.show_more": "展开",
  "content_warning.show_short": "展示",
  "conversation.delete": "删除对话",
  "conversation.mark_as_read": "标为已读",
  "conversation.open": "查看对话",
  "conversation.with": "与 {names}",
  "copy_icon_button.copied": "已复制到剪贴板",
  "copy_icon_button.copy_this_text": "复制链接到剪贴板",
  "copypaste.copied": "已复制",
  "copypaste.copy_to_clipboard": "复制到剪贴板",
  "custom_feed.delete": "删除时间线",
  "custom_feed.edit": "编辑时间线",
  "custom_feed.manage_accounts": "管理成员",
  "custom_feed.options": "时间线选项",
  "custom_feeds.add_to_feed": "添加到时间线",
  "custom_feeds.create": "创建",
  "custom_feeds.create_a_list_to_organize": "创建新自定义动态以整理你的关注动态。",
  "custom_feeds.exclusive_hint": "如果某人在此自定义时间线中，可以在你的首页时间线中隐藏他们，以避免重复看到他们的贴文。",
  "custom_feeds.feed_name": "时间线名称",
  "custom_feeds.manage_accounts": "管理时间线成员",
  "custom_feeds.manage_accounts_title": "管理时间线成员",
  "custom_feeds.no_custom_feeds_yet": "暂无自定义时间线。",
  "custom_feeds.replies_policy.members": "时间线成员",
  "custom_feeds.show_replies_to": "包含时间线成员对以下内容的回复",
  "custom_homepage.about": "关于",
  "custom_homepage.about_this_server": "关于本站点",
  "custom_homepage.administered_by": "管理员",
  "custom_homepage.contact": "联系方式：",
  "custom_homepage.latest_activity": "最近活动",
  "custom_homepage.these_are_the_latest_posts": "这些是来自本站点账户的最新 40 条贴文。",
  "directory.federated": "来自已知的联邦宇宙",
  "directory.local": "仅来自 {domain}",
  "directory.new_arrivals": "新用户",
  "directory.recently_active": "近期活跃",
  "disabled_account_banner.account_settings": "账户设置",
  "disabled_account_banner.text": "你的账户 {disabledAccount} 当前已被停用。",
  "dismissable_banner.community_timeline": "以下是 {domain} 上的用户最近发布的公开贴文。",
  "dismissable_banner.dismiss": "关闭",
  "dismissable_banner.public_timeline": "以下是 {domain} 用户所关注的联邦宇宙用户的最新公开贴文。",
  "domain_block_modal.block": "屏蔽站点",
  "domain_block_modal.block_account_instead": "改为屏蔽 @{name}",
  "domain_block_modal.they_can_interact_with_old_posts": "该站点的用户可以与你过去的贴文互动。",
  "domain_block_modal.they_cant_follow": "该站点的任何人都无法关注你。",
  "domain_block_modal.they_wont_know": "他们不会知道自己已被屏蔽。",
  "domain_block_modal.title": "是否屏蔽站点？",
  "domain_block_modal.you_will_lose_num_followers": "你将失去 {followersCount, plural, other{{followersCountDisplay} 个粉丝}}和{followingCount, plural, other{{followingCountDisplay} 个关注}}。",
  "domain_block_modal.you_will_lose_relationships": "你将失去来自该站点的所有粉丝与关注。",
  "domain_block_modal.you_wont_see_posts": "你将不会看到来自此站点用户的贴文或通知。",
  "dropdown.empty": "选择一个选项",
  "email_subscriptions.email": "邮箱",
  "email_subscriptions.form.action": "订阅",
  "email_subscriptions.form.bottom": "无需创建 Mastodon 账户即可在你的收件箱中接收贴文。随时可取消订阅。有关更多信息，请参阅 <a>隐私政策</a>。",
  "email_subscriptions.form.title": "订阅来自 {name} 的邮件更新",
  "email_subscriptions.submitted.lead": "请检查你的收件箱，查收一封邮件以完成邮件更新的订阅。",
  "email_subscriptions.submitted.title": "最后一步",
  "email_subscriptions.validation.email.blocked": "已屏蔽的邮件提供商",
  "email_subscriptions.validation.email.invalid": "无效的邮件地址",
  "embed.instructions": "复制以下代码，将此贴文嵌入到你的网站。",
  "embed.preview": "效果预览如下：",
  "emoji_button.activity": "活动",
  "emoji_button.clear": "清除",
  "emoji_button.custom": "自定义",
  "emoji_button.flags": "旗帜",
  "emoji_button.food": "食物与饮料",
  "emoji_button.label": "插入表情",
  "emoji_button.nature": "自然",
  "emoji_button.not_found": "未找到匹配的表情",
  "emoji_button.objects": "物体",
  "emoji_button.people": "人物",
  "emoji_button.recent": "常用",
  "emoji_button.search": "搜索…",
  "emoji_button.search_results": "搜索结果",
  "emoji_button.symbols": "符号",
  "emoji_button.travel": "旅行与地点",
  "empty_column.account_featured.other": "{acct} 尚未精选任何内容。",
  "empty_column.account_featured_self.no_collections_button": "创建一个合集",
  "empty_column.account_featured_self.no_collections_hide_tab": "改为隐藏此选项卡",
  "empty_column.account_featured_self.showcase_accounts": "展示你喜爱的账户",
  "empty_column.account_featured_self.showcase_accounts_desc": "合集是由账户组成的精选列表，可帮助其他人发现更多 Fediverse 内容。",
  "empty_column.account_featured_unknown.other": "此账户尚未精选任何内容。",
  "empty_column.account_hides_collections": "该用户选择不公开此信息",
  "empty_column.account_suspended": "账户已被封禁",
  "empty_column.account_timeline": "这里还没有贴文！",
  "empty_column.account_unavailable": "账户不可用",
  "empty_column.blocks": "你还没有屏蔽任何用户。",
  "empty_column.bookmarked_statuses": "你还没有收藏任何贴文。当你收藏一条贴文后，它会显示在这里。",
  "empty_column.collections": "{acct} 尚未创建任何合集。",
  "empty_column.collections.featured_in": "你尚未被添加到任何合集。",
  "empty_column.collections.featured_in_undiscoverable": "为了让其他人将你添加到合集，你需要在 <link>偏好设置 > 隐私与触达</link>中允许在发现体验中进行展示",
  "empty_column.collections_self": "你尚未创建任何合集。",
  "empty_column.community": "本站时间线是空的。公开发点什么来让它滚动起来吧！",
  "empty_column.custom_feed": "此自定义时间线中暂无内容。当此动态的成员发布新贴文时，它们会显示在这里。",
  "empty_column.direct": "你还没有私信。当你发出或收到私信时，它将显示在此处。",
  "empty_column.disabled_feed": "此时间线已被你的站点管理员禁用。",
  "empty_column.domain_blocks": "尚无屏蔽的站点。",
  "empty_column.explore_statuses": "目前没有热门内容。稍后再来看看吧！",
  "empty_column.favourited_statuses": "你还没有点赞任何贴文。当你点赞一条贴文后，它会显示在这里。",
  "empty_column.favourites": "还没有人点赞这条贴文。当有人点赞时，点赞的人会显示在这里。",
  "empty_column.follow_requests": "你还没有收到关注请求。当你收到请求时，它会显示在这里。",
  "empty_column.followed_tags": "你还没有关注任何话题。当你关注后，它们会显示在这里。",
  "empty_column.hashtag": "此话题下还没有内容。",
  "empty_column.home": "你的主页时间线是空的！关注更多人来填充它吧。",
  "empty_column.list": "此列表还没有内容。当此列表的成员发布新贴文时，它们会出现在这里。",
  "empty_column.mutes": "你还没有隐藏任何用户。",
  "empty_column.notification_requests": "都看完了！这里没有内容。当你收到新通知时，它们会根据你的设置显示在这里。",
  "empty_column.notifications": "你还没有任何通知。当其它人与你互动时，你会在这里看到互动通知。",
  "empty_column.public": "这里还没有内容！公开发一些内容，或手动关注其它站点的用户来填充它吧",
  "empty_state.no_results": "无结果",
  "error.no_hashtag_feed_access": "加入或登录后即可查看并关注此话题。",
  "error.unexpected_crash.explanation": "由于我们代码中的错误或浏览器兼容性问题，此页面无法正确显示。",
  "error.unexpected_crash.explanation_addons": "此页面无法正确显示。此错误很可能是由浏览器插件或自动翻译工具引起的。",
  "error.unexpected_crash.next_steps": "尝试刷新页面。如果这没有帮助，你仍然可以通过其它浏览器或原生应用使用 Mastodon。",
  "error.unexpected_crash.next_steps_addons": "尝试禁用它们并刷新页面。如果这没有帮助，你仍然可以通过其它浏览器或原生应用使用 Mastodon。",
  "errors.unexpected_crash.copy_stacktrace": "复制追踪堆栈到剪贴板",
  "errors.unexpected_crash.report_issue": "报告问题",
  "explore.suggested_follows": "人物",
  "explore.title": "热门",
  "explore.trending_links": "新闻",
  "explore.trending_statuses": "贴文",
  "explore.trending_tags": "话题",
  "featured_carousel.current": "<sr>贴文</sr> {current, number} / {max, number}",
  "featured_carousel.header": "{count, plural, other {置顶贴文}}",
  "featured_carousel.slide": "第 {current, number} / {max, number} 条贴文",
  "featured_tags.more_items": "+{count}",
  "featured_tags.suggestions": "最近你发布了关于 {items} 的贴文。要将这些添加到精选话题吗？",
  "featured_tags.suggestions.add": "添加",
  "featured_tags.suggestions.added": "你可以随时在<link>编辑个人资料 > 精选话题</link>下管理你的精选话题。",
  "featured_tags.suggestions.dismiss": "不用了",
  "filter_modal.added.context_mismatch_explanation": "此过滤规则类别不适用于你访问此贴文的情景。如果你希望在该情景中也过滤该贴文，则必须编辑该过滤规则。",
  "filter_modal.added.context_mismatch_title": "情景不一致！",
  "filter_modal.added.expired_explanation": "此过滤规则类别已过期，你需要更改其到期日期才能使其生效。",
  "filter_modal.added.expired_title": "过滤规则已过期！",
  "filter_modal.added.review_and_configure": "要检查并进一步配置此过滤规则类别，请前往{settings_link}。",
  "filter_modal.added.review_and_configure_title": "过滤规则设置",
  "filter_modal.added.settings_link": "设置页",
  "filter_modal.added.short_explanation": "此贴文已被添加到以下过滤规则类别：{title}。",
  "filter_modal.added.title": "已添加过滤规则！",
  "filter_modal.select_filter.context_mismatch": "不适用于此情景",
  "filter_modal.select_filter.expired": "已过期",
  "filter_modal.select_filter.prompt_new": "新类别：{name}",
  "filter_modal.select_filter.search": "搜索或创建",
  "filter_modal.select_filter.subtitle": "使用现有类别或创建一个新的类别",
  "filter_modal.select_filter.title": "过滤此贴文",
  "filter_modal.title.status": "过滤一篇贴文",
  "filter_warning.matches_filter": "命中过滤规则“<span>{title}</span>”",
  "filtered_notifications_banner.pending_requests": "来自你可能认识的 {count, plural, =0 {} other {#}} 个人",
  "filtered_notifications_banner.title": "已过滤的通知",
  "firehose.all": "全部",
  "firehose.local": "本站",
  "firehose.remote": "外站",
  "follow_request.authorize": "同意",
  "follow_request.reject": "拒绝",
  "follow_requests.unlocked_explanation": "尽管你的账户未锁定，但 {domain} 的管理员认为你可能希望手动审核来自这些账户的关注请求。",
  "follow_suggestions.curated_suggestion": "管理团队精选",
  "follow_suggestions.dismiss": "不再显示",
  "follow_suggestions.featured_longer": "{domain} 管理团队精选",
  "follow_suggestions.friends_of_friends_longer": "在你关注的人中很受欢迎",
  "follow_suggestions.hints.featured": "此账户由 {domain} 管理团队精选。",
  "follow_suggestions.hints.friends_of_friends": "此账户在你关注的人中很受欢迎。",
  "follow_suggestions.hints.most_followed": "此账户是 {domain} 上被关注最多的账户之一。",
  "follow_suggestions.hints.most_interactions": "此账户最近在 {domain} 上获得了大量关注。",
  "follow_suggestions.hints.similar_to_recently_followed": "此账户与你最近关注的账户相似。",
  "follow_suggestions.personalized_suggestion": "个性化推荐",
  "follow_suggestions.popular_suggestion": "热门推荐",
  "follow_suggestions.popular_suggestion_longer": "{domain} 上的热门用户",
  "follow_suggestions.similar_to_recently_followed_longer": "与你最近关注的账户类似",
  "follow_suggestions.view_all": "查看全部",
  "follow_suggestions.who_to_follow": "推荐关注",
  "followed_tags": "关注的话题",
  "followers.hide_other_followers": "该用户选择不公开其他粉丝",
  "followers.title": "正在关注 {name}",
  "following.hide_other_following": "该用户选择不公开其关注的其他用户",
  "following.title": "{name} 关注了 Ta",
  "footer.about": "关于",
  "footer.about_mastodon": "关于 Mastodon",
  "footer.about_server": "关于 {domain}",
  "footer.about_this_server": "关于",
  "footer.directory": "账户目录",
  "footer.get_app": "获取应用",
  "footer.keyboard_shortcuts": "快捷键",
  "footer.privacy_policy": "隐私政策",
  "footer.privacy_policy_short": "隐私政策",
  "footer.source_code": "查看源代码",
  "footer.status": "状态",
  "footer.terms_of_service": "服务条款",
  "footer.terms_of_service_short": "服务条款",
  "form_error.blank": "字段不能为空。",
  "form_field.optional": "(可选)",
  "getting_started.heading": "开始使用",
  "hashtag.admin_moderation": "打开 #{name} 的管理界面",
  "hashtag.browse": "浏览 #{hashtag} 中的贴文",
  "hashtag.browse_from_account": "浏览 @{name} 在 #{hashtag} 中的贴文",
  "hashtag.column_header.tag_mode.all": "和 {additional}",
  "hashtag.column_header.tag_mode.any": "或 {additional}",
  "hashtag.column_header.tag_mode.none": "不含 {additional}",
  "hashtag.column_settings.select.no_options_message": "未找到任何建议",
  "hashtag.column_settings.select.placeholder": "输入话题…",
  "hashtag.column_settings.tag_mode.all": "所有这些",
  "hashtag.column_settings.tag_mode.any": "任何一个",
  "hashtag.column_settings.tag_mode.none": "以下皆非",
  "hashtag.column_settings.tag_toggle": "为此栏目添加额外标签",
  "hashtag.counter_by_accounts": "{count, plural, other {{counter} 位参与者}}",
  "hashtag.counter_by_uses": "{count, plural, other {{counter} 贴文}}",
  "hashtag.counter_by_uses_today": "{count, plural, other {今日 {counter} 条贴文}}",
  "hashtag.feature": "在账户页推荐",
  "hashtag.follow": "关注话题",
  "hashtag.mute": "隐藏 #{hashtag}",
  "hashtag.options": "话题选项",
  "hashtag.unfeature": "不在账户页推荐",
  "hashtag.unfollow": "取关话题",
  "hashtags.add_more_tags": "为此栏添加更多话题…",
  "hashtags.add_more_tags_to_column": "为 #{tag} 添加更多话题",
  "hashtags.and_other": "…以及{count, plural, other {其它 # 个}}",
  "hints.profiles.followers_may_be_missing": "此账户的粉丝列表可能不完整。",
  "hints.profiles.follows_may_be_missing": "此账户的关注列表可能不完整。",
  "hints.profiles.posts_may_be_missing": "此账户的部分贴文可能在此并未显示。",
  "hints.profiles.see_more_followers": "在 {domain} 查看更多粉丝",
  "hints.profiles.see_more_follows": "在 {domain} 查看更多关注",
  "hints.profiles.see_more_posts": "在 {domain} 查看更多贴文",
  "home.column_settings.show_quotes": "显示引用",
  "home.column_settings.show_reblogs": "显示转发",
  "home.column_settings.show_replies": "显示回复",
  "home.hide_announcements": "隐藏公告",
  "home.pending_critical_update.body": "请尽快更新你的 Mastodon 站点！",
  "home.pending_critical_update.link": "查看更新",
  "home.pending_critical_update.title": "有可用的紧急安全更新！",
  "home.show_announcements": "显示公告",
  "ignore_notifications_modal.bots_title": "是否忽略来自机器人的通知？",
  "ignore_notifications_modal.disclaimer": "Mastodon 不会通知用户你已忽略他们的通知。忽略通知并不能阻止消息本身的发送。",
  "ignore_notifications_modal.filter_instead": "改为过滤",
  "ignore_notifications_modal.filter_to_act_users": "你仍然可以接受、拒绝或举报用户",
  "ignore_notifications_modal.filter_to_avoid_confusion": "过滤有助于避免潜在的混淆",
  "ignore_notifications_modal.filter_to_review_separately": "你可以单独查看被过滤的通知",
  "ignore_notifications_modal.ignore": "忽略通知",
  "ignore_notifications_modal.limited_accounts_title": "是否忽略来自受限账户的通知？",
  "ignore_notifications_modal.new_accounts_title": "是否忽略来自新账户的通知？",
  "ignore_notifications_modal.not_followers_title": "是否忽略来自未关注你的人的通知？",
  "ignore_notifications_modal.not_following_title": "是否忽略你没有关注的人发来的通知？",
  "ignore_notifications_modal.private_mentions_title": "是否忽略不请自来的私信？",
  "info_button.label": "帮助",
  "info_button.what_is_alt_text": "<h1>什么是替代文本？</h1> <p>替代文本为视障人士、网速较慢的用户或寻求额外背景信息的用户提供图像描述。</p> <p>通过编写清晰、简洁、客观的替代文本，你可以为所有人改善可访问性和理解程度。</p> <ul> <li>捕捉重要元素</li> <li>总结图片中的文字</li> <li>使用常规句式</li> <li>避免冗余信息</li> <li>在图表或地图等复杂视觉内容中，着重描述趋势和关键发现</li> </ul>",
  "interaction_modal.action": "要和 {name} 的贴文互动，你需要登录到你在Mastodon站点上注册的账户。",
  "interaction_modal.action_follow": "要关注 {name}，你需要登录你在使用的任意 Mastodon 站点上的账户。",
  "interaction_modal.go": "前往",
  "interaction_modal.no_account_yet": "还没有账户吗？",
  "interaction_modal.on_another_server": "在另一个站点",
  "interaction_modal.on_this_server": "在此站点",
  "interaction_modal.title": "登录以继续",
  "interaction_modal.username_prompt": "例如：{example}",
  "intervals.full.days": "{number, plural, other {# 天}}",
  "intervals.full.hours": "{number, plural, other {# 小时}}",
  "intervals.full.minutes": "{number, plural, other {# 分钟}}",
  "keyboard_shortcuts.back": "返回",
  "keyboard_shortcuts.blocked": "打开已屏蔽用户列表",
  "keyboard_shortcuts.boost": "转发贴文",
  "keyboard_shortcuts.column": "选中该栏",
  "keyboard_shortcuts.compose": "选中撰写框",
  "keyboard_shortcuts.description": "描述",
  "keyboard_shortcuts.direct": "打开私信栏",
  "keyboard_shortcuts.down": "在列表中向下移动",
  "keyboard_shortcuts.enter": "打开贴文",
  "keyboard_shortcuts.explore": "打开热门时间线",
  "keyboard_shortcuts.favourite": "点赞贴文",
  "keyboard_shortcuts.favourites": "打开点赞列表",
  "keyboard_shortcuts.federated": "打开跨站时间线",
  "keyboard_shortcuts.heading": "快捷键",
  "keyboard_shortcuts.home": "打开主页时间线",
  "keyboard_shortcuts.hotkey": "快捷键",
  "keyboard_shortcuts.keys.alt": "Alt",
  "keyboard_shortcuts.keys.backspace": "退格键",
  "keyboard_shortcuts.keys.enter": "回车键",
  "keyboard_shortcuts.keys.esc": "Esc",
  "keyboard_shortcuts.keys.page_down": "向下翻页键",
  "keyboard_shortcuts.keys.page_up": "向上翻页键",
  "keyboard_shortcuts.legend": "显示本图例",
  "keyboard_shortcuts.load_more": "将焦点移至“加载更多”按钮",
  "keyboard_shortcuts.local": "打开本站时间线",
  "keyboard_shortcuts.mention": "提及作者",
  "keyboard_shortcuts.muted": "打开隐藏用户列表",
  "keyboard_shortcuts.my_profile": "打开你的账户页",
  "keyboard_shortcuts.notifications": "打开通知栏",
  "keyboard_shortcuts.open_media": "打开媒体",
  "keyboard_shortcuts.pinned": "打开置顶贴文列表",
  "keyboard_shortcuts.profile": "打开作者的账户页",
  "keyboard_shortcuts.quote": "引用贴文",
  "keyboard_shortcuts.reply": "回复贴文",
  "keyboard_shortcuts.requests": "打开关注请求列表",
  "keyboard_shortcuts.search": "选中搜索栏",
  "keyboard_shortcuts.spoilers": "显示/隐藏内容警告字段",
  "keyboard_shortcuts.start": "打开“新手入门”栏目",
  "keyboard_shortcuts.toggle_hidden": "显示/隐藏内容警告之后的文本",
  "keyboard_shortcuts.toggle_sensitivity": "显示/隐藏媒体",
  "keyboard_shortcuts.toot": "创建新贴文",
  "keyboard_shortcuts.top": "移至列表顶部",
  "keyboard_shortcuts.translate": "翻译贴文",
  "keyboard_shortcuts.unfocus": "取消选中撰写文本区/搜索框",
  "keyboard_shortcuts.up": "在列表中上移",
  "learn_more_link.got_it": "明白了",
  "learn_more_link.learn_more": "了解更多",
  "lightbox.close": "关闭",
  "lightbox.next": "下一个",
  "lightbox.previous": "上一个",
  "lightbox.zoom_in": "缩放至实际大小",
  "lightbox.zoom_out": "缩放以适应屏幕",
  "limited_account_hint.action": "仍然显示账户",
  "limited_account_hint.title": "此账户或站点已被 {domain} 的管理员隐藏。",
  "link_preview.author": "作者 {name}",
  "link_preview.more_from_author": "{name} 的更多内容",
  "link_preview.shares": "{count, plural, other {{counter} 贴文}}",
  "lists.add_member": "添加",
  "lists.add_to_list": "添加到列表",
  "lists.add_to_lists": "将 {name} 添加到列表",
  "lists.create": "创建",
  "lists.create_a_list_to_organize": "创建新列表以整理你的首页动态",
  "lists.create_list": "创建列表",
  "lists.delete": "删除列表",
  "lists.done": "完成",
  "lists.edit": "编辑列表",
  "lists.exclusive": "在首页中隐藏列表成员",
  "lists.exclusive_hint": "如果某人在此列表中，Ta的贴文会从你的首页时间线中隐藏，以避免重复看到他们的贴文。",
  "lists.find_users_to_add": "查找要添加的用户",
  "lists.list_members_count": "{count, plural, other {# 人}}",
  "lists.list_name": "列表名称",
  "lists.new_list_name": "新列表名称",
  "lists.no_lists_yet": "尚无列表。",
  "lists.no_members_yet": "尚无成员。",
  "lists.no_results_found": "未找到结果。",
  "lists.remove_member": "移除",
  "lists.replies_policy.followed": "任何已关注的用户",
  "lists.replies_policy.list": "列表中的成员",
  "lists.replies_policy.none": "不显示任何回复",
  "lists.save": "保存",
  "lists.search": "搜索",
  "lists.show_replies_to": "显示列表成员给以下用户的回复",
  "load_pending": "{count, plural, other {# 个新项目}}",
  "loading_indicator.label": "加载中…",
  "media_gallery.hide": "隐藏",
  "messages.new": "新建",
  "moved_to_account_banner.text": "你的账户 {disabledAccount} 目前已被禁用，因为你已将它迁移至 {movedToAccount}。",
  "mute_modal.hide_from_notifications": "在通知中隐藏",
  "mute_modal.hide_options": "隐藏选项",
  "mute_modal.indefinite": "直到我取消隐藏",
  "mute_modal.show_options": "显示选项",
  "mute_modal.they_can_mention_and_follow": "对方仍然可以提及和关注你，但你不会看到Ta。",
  "mute_modal.they_wont_know": "对方不会知道自己被隐藏。",
  "mute_modal.title": "是否隐藏用户？",
  "mute_modal.you_wont_see_mentions": "你将不会看到提及他们的贴文。",
  "mute_modal.you_wont_see_posts": "对方仍然能看到你的贴文，但你将看不到Ta的贴文。",
  "navigation_bar.about": "关于",
  "navigation_bar.account_settings": "密码与安全",
  "navigation_bar.administration": "管理",
  "navigation_bar.advanced_interface": "在高级网页界面中打开",
  "navigation_bar.automated_deletion": "自动删除贴文",
  "navigation_bar.blocked_accounts": "已屏蔽的账户",
  "navigation_bar.blocks": "已屏蔽用户",
  "navigation_bar.bookmarks": "收藏夹",
  "navigation_bar.collections": "合集",
  "navigation_bar.direct": "私信",
  "navigation_bar.domain_blocks": "已屏蔽的站点",
  "navigation_bar.favourites": "点赞",
  "navigation_bar.filters": "已隐藏的关键词",
  "navigation_bar.follow_requests": "关注请求",
  "navigation_bar.followed_tags": "关注的话题",
  "navigation_bar.followers_and_following": "粉丝与关注",
  "navigation_bar.follows_and_followers": "关注与粉丝",
  "navigation_bar.import_export": "导入与导出",
  "navigation_bar.liked_posts": "点赞的贴文",
  "navigation_bar.lists": "列表",
  "navigation_bar.live_feed_local": "实时动态（本站）",
  "navigation_bar.live_feed_public": "实时动态（跨站）",
  "navigation_bar.logout": "退出登录",
  "navigation_bar.main": "主要",
  "navigation_bar.moderation": "运营",
  "navigation_bar.more": "更多",
  "navigation_bar.mutes": "已隐藏的用户",
  "navigation_bar.opened_in_classic_interface": "贴文、账户和其它特定页面默认在经典网页界面中打开。",
  "navigation_bar.powered_by_mastodon": "由 {logo}Mastodon 提供技术支持",
  "navigation_bar.preferences": "设置",
  "navigation_bar.privacy_and_reach": "隐私与可见范围",
  "navigation_bar.saved_posts": "已保存的贴文",
  "navigation_bar.search": "搜索",
  "navigation_bar.search_trends": "搜索 / 热门",
  "navigation_bar.sign_out": "登出",
  "navigation_panel.collapse_followed_tags": "折叠已关注的话题菜单",
  "navigation_panel.collapse_lists": "折叠列表菜单",
  "navigation_panel.expand_followed_tags": "展开已关注话题菜单",
  "navigation_panel.expand_lists": "展开列表菜单",
  "not_signed_in_indicator.not_signed_in": "你需要登录才能访问此内容。",
  "notification.added_to_collection": "{name} 把你添加到了合集",
  "notification.admin.report": "{name} 举报了 {target}",
  "notification.admin.report_account": "{name} 因 {category} 举报了来自 {target} 的 {count, plural, other {# 条贴文}}",
  "notification.admin.report_account_other": "{name} 举报了来自 {target} 的 {count, plural, other {# 条贴文}}",
  "notification.admin.report_statuses": "{name} 因 {category} 举报了 {target}",
  "notification.admin.report_statuses_other": "{name} 举报了 {target}",
  "notification.admin.sign_up": "{name} 注册了",
  "notification.admin.sign_up.name_and_others": "{name} 和{count, plural, other {其它 # 人}} 注册了",
  "notification.annual_report.message": "你的 {year} #年度报告 已准备就绪！快来 Mastodon 回顾你的年度高光和难忘时刻吧！",
  "notification.annual_report.view": "查看 #Wrapstodon 年度回顾",
  "notification.collection_update": "{name} 编辑了你所在的合集",
  "notification.favourite": "{name} 点赞了你的贴文",
  "notification.favourite.name_and_others_with_link": "{name}和<a>{count, plural, other {其它 # 人}}</a>点赞了你的贴文",
  "notification.favourite_pm": "{name} 点赞了你的私信",
  "notification.favourite_pm.name_and_others_with_link": "{name}和<a>{count, plural, other {其它 # 人}}</a>点赞了你的私信",
  "notification.follow": "{name} 关注了你",
  "notification.follow.name_and_others": "{name} 和<a>{count, plural, other {其它 # 人}}</a>关注了你",
  "notification.follow_request": "{name} 请求关注你",
  "notification.follow_request.name_and_others": "{name} 和{count, plural, other {其它 # 人}}请求关注你",
  "notification.label.mention": "提及",
  "notification.label.private_mention": "私信",
  "notification.label.private_reply": "私信回复",
  "notification.label.quote": "{name} 引用了你的贴文",
  "notification.label.reply": "回复",
  "notification.mention": "提及",
  "notification.mentioned_you": "{name} 提到了你",
  "notification.moderation-warning.learn_more": "了解更多",
  "notification.moderation_warning": "你收到了一条管理警告",
  "notification.moderation_warning.action_delete_statuses": "你的部分贴文已被移除。",
  "notification.moderation_warning.action_disable": "你的账户已被禁用。",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "你的部分贴文已被标记为敏感。",
  "notification.moderation_warning.action_none": "你的账户收到了一条管理警告。",
  "notification.moderation_warning.action_sensitive": "从现在起，你的贴文将被标记为敏感。",
  "notification.moderation_warning.action_silence": "你的账户已被限制。",
  "notification.moderation_warning.action_suspend": "你的账户已被封禁。",
  "notification.own_poll": "你的投票已结束",
  "notification.poll": "你参与的投票已结束",
  "notification.quoted_update": "{name} 编辑了一条你之前引用过的贴文",
  "notification.reblog": "{name} 转发了你的贴文",
  "notification.reblog.name_and_others_with_link": "{name} 和<a>{count, plural, other {其它 # 人}}</a> 转发了你的贴文",
  "notification.relationships_severance_event": "已与 {name} 断开连接",
  "notification.relationships_severance_event.account_suspension": "{from} 的一名管理员已封禁 {target}，这意味着你将无法再收到来自对方的更新，也无法与对方互动。",
  "notification.relationships_severance_event.domain_block": "{from} 的一名管理员已屏蔽 {target}，其中包括你的 {followersCount} 名粉丝以及你关注的 {followingCount, plural, other {# 个账户}}。",
  "notification.relationships_severance_event.learn_more": "了解更多",
  "notification.relationships_severance_event.user_domain_block": "你已屏蔽 {target}，移除了你的 {followersCount} 位粉丝和你关注的 {followingCount, plural, other {# 个账户}}。",
  "notification.status": "{name} 发布了新贴文",
  "notification.update": "{name} 编辑了贴文",
  "notification_requests.accept": "接受",
  "notification_requests.accept_multiple": "{count, plural, other {接受 # 个请求…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, other {接受请求}}",
  "notification_requests.confirm_accept_multiple.message": "你将会接受 {count, plural, other {# 个通知请求}}。确定要继续吗？",
  "notification_requests.confirm_accept_multiple.title": "是否接受通知请求？",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, other {忽略请求}}",
  "notification_requests.confirm_dismiss_multiple.message": "你将会忽略 {count, plural, other {# 个通知请求}}。你将无法再轻松访问{count, plural, other {它们}}。确定要继续吗？",
  "notification_requests.confirm_dismiss_multiple.title": "是否忽略通知请求？",
  "notification_requests.dismiss": "关闭",
  "notification_requests.dismiss_multiple": "{count, plural, other {忽略 # 个请求…}}",
  "notification_requests.edit_selection": "编辑",
  "notification_requests.exit_selection": "完成",
  "notification_requests.explainer_for_limited_account": "来自此账户的通知已被过滤，因为该账户已被管理员限制。",
  "notification_requests.explainer_for_limited_remote_account": "来自此账户的通知已被过滤，因为该账户或其所在站点已被管理员限制。",
  "notification_requests.maximize": "最大化",
  "notification_requests.minimize_banner": "最小化已过滤通知横幅",
  "notification_requests.notifications_from": "来自 {name} 的通知",
  "notification_requests.title": "已过滤的通知",
  "notification_requests.view": "查看通知",
  "notifications.clear": "清除通知",
  "notifications.clear_confirmation": "你确定要永久清除你的所有通知吗？",
  "notifications.clear_title": "是否清除通知？",
  "notifications.column_settings.admin.report": "新举报：",
  "notifications.column_settings.admin.sign_up": "新注册：",
  "notifications.column_settings.alert": "桌面通知",
  "notifications.column_settings.collections": "合集：",
  "notifications.column_settings.favourite": "点赞：",
  "notifications.column_settings.filter_bar.advanced": "显示所有类别",
  "notifications.column_settings.filter_bar.category": "快速筛选栏",
  "notifications.column_settings.follow": "新粉丝：",
  "notifications.column_settings.follow_request": "新的关注请求：",
  "notifications.column_settings.group": "群组",
  "notifications.column_settings.mention": "提及：",
  "notifications.column_settings.poll": "投票结果：",
  "notifications.column_settings.push": "推送通知",
  "notifications.column_settings.quote": "引用贴文：",
  "notifications.column_settings.reblog": "转发：",
  "notifications.column_settings.show": "在通知栏中显示",
  "notifications.column_settings.sound": "播放声音",
  "notifications.column_settings.status": "新贴文：",
  "notifications.column_settings.unread_notifications.category": "未读通知",
  "notifications.column_settings.unread_notifications.highlight": "高亮显示未读通知",
  "notifications.column_settings.update": "编辑：",
  "notifications.filter.all": "全部",
  "notifications.filter.boosts": "转发",
  "notifications.filter.collections": "合集",
  "notifications.filter.favourites": "点赞",
  "notifications.filter.follows": "关注",
  "notifications.filter.mentions": "提及",
  "notifications.filter.polls": "投票结果",
  "notifications.filter.statuses": "你关注的人的动态",
  "notifications.grant_permission": "授予权限。",
  "notifications.group": "{count} 条通知",
  "notifications.mark_as_read": "将所有通知标记为已读",
  "notifications.permission_denied": "由于你此前拒绝了浏览器权限请求，桌面通知功能将不可用",
  "notifications.permission_denied_alert": "桌面通知无法启用，因为浏览器权限此前已被拒绝",
  "notifications.permission_required": "桌面通知不可用，因为尚未授予所需权限。",
  "notifications.policy.accept": "接受",
  "notifications.policy.accept_hint": "在通知中显示",
  "notifications.policy.drop": "忽略",
  "notifications.policy.drop_hint": "送往虚空，永不再见",
  "notifications.policy.filter": "筛选",
  "notifications.policy.filter_bots_hint": "标记为无人值守的账户",
  "notifications.policy.filter_bots_title": "机器人",
  "notifications.policy.filter_hint": "发送到过滤通知收件箱",
  "notifications.policy.filter_limited_accounts_hint": "受站点管理员限制",
  "notifications.policy.filter_limited_accounts_title": "被限制的账户",
  "notifications.policy.filter_new_accounts.hint": "在过去 {days, plural, other{# 天}}内创建的账户",
  "notifications.policy.filter_new_accounts_title": "新账户",
  "notifications.policy.filter_not_followers_hint": "包括关注你不足 {days, plural, other{# 天}} 的用户",
  "notifications.policy.filter_not_followers_title": "没有关注你的人",
  "notifications.policy.filter_not_following_hint": "直到你手动批准对方",
  "notifications.policy.filter_not_following_title": "你没有关注的用户",
  "notifications.policy.filter_private_mentions_hint": "除非该通知为对你自己的提及的回复，或者你关注了发送者，否则通知将被过滤",
  "notifications.policy.filter_private_mentions_title": "不请自来的私信",
  "notifications.policy.title": "管理来自…的通知",
  "notifications.settings": "通知设置",
  "notifications_permission_banner.enable": "启用桌面通知",
  "notifications_permission_banner.how_to_control": "要在 Mastodon 未打开时接收通知，请启用桌面通知。启用后，你可以通过上方的 {icon} 按钮精确控制哪些类型的互动会生成桌面通知。",
  "notifications_permission_banner.title": "不再错过任何内容",
  "onboarding.follows.back": "返回",
  "onboarding.follows.empty": "很抱歉，现在无法显示任何结果。你可以尝试使用搜索或浏览发现页面来寻找可关注的人，或稍后再试。",
  "onboarding.follows.next": "下一步：设置你的个人资料",
  "onboarding.follows.search": "搜索",
  "onboarding.follows.title": "关注一些人以开始浏览",
  "onboarding.profile.discoverable": "让我的账户可被发现",
  "onboarding.profile.discoverable_hint": "当你选择在 Mastodon 上可被发现时，你的贴文可能会出现在搜索结果和热门中，你的账户也可能会被推荐给与你有相似兴趣的人。",
  "onboarding.profile.display_name": "昵称",
  "onboarding.profile.display_name_hint": "你的全名或昵称…",
  "onboarding.profile.finish": "完成",
  "onboarding.profile.note": "简介",
  "onboarding.profile.note_hint": "你可以在此 @提及他人或 #话题…",
  "onboarding.profile.title": "设置个人资料",
  "onboarding.profile.upload_avatar": "上传头像",
  "onboarding.profile.upload_header": "上传账户页背景图",
  "password_confirmation.exceeds_maxlength": "确认密码超出最大长度",
  "password_confirmation.mismatching": "两次输入的密码不一致",
  "picture_in_picture.restore": "还原",
  "poll.closed": "已结束",
  "poll.refresh": "刷新",
  "poll.reveal": "查看结果",
  "poll.total_people": "{count, plural, other {# 人}}",
  "poll.total_votes": "{count, plural, other {# 票}}",
  "poll.vote": "投票",
  "poll.voted": "你已为该选项投票",
  "poll.votes": "{votes, plural, other {# 票}}",
  "poll_button.add_poll": "添加投票",
  "poll_button.remove_poll": "移除投票",
  "privacy.change": "更改贴文可见性",
  "privacy.direct.long": "贴文中提及的所有人",
  "privacy.direct.short": "私信",
  "privacy.message.short": "私信",
  "privacy.private.long": "仅粉丝可见",
  "privacy.private.short": "粉丝",
  "privacy.public.long": "Mastodon 内外皆可见",
  "privacy.public.short": "公开",
  "privacy.quote.anyone": "{visibility}，允许引用",
  "privacy.quote.disabled": "{visibility} / 禁止引用",
  "privacy.quote.limited": "{visibility} / 有限引用",
  "privacy.unlisted.additional": "此选项与“公开”行为一致，但该贴文不会出现在公开时间线、话题、发现页或 Mastodon 搜索中，即使你已将自己的账户设为可发现。",
  "privacy.unlisted.long": "不显示在 Mastodon 的搜索结果、热门、公共时间线上",
  "privacy.unlisted.short": "半公开",
  "privacy_policy.last_updated": "最后更新于 {date}",
  "privacy_policy.title": "隐私政策",
  "quote_error.edit": "编辑贴文时无法添加引用。",
  "quote_error.poll": "不允许引用带投票的贴文。",
  "quote_error.private_mentions": "私信中不允许使用引用功能。",
  "quote_error.quote": "一次只能引用一条贴文。",
  "quote_error.unauthorized": "你无权引用此贴文。",
  "quote_error.upload": "不能引用带媒体附件的贴文。",
  "recommended": "推荐",
  "refresh": "刷新",
  "regeneration_indicator.please_stand_by": "请稍候。",
  "regeneration_indicator.preparing_your_home_feed": "正在准备你的主页动态…",
  "relative_time.days": "{number}天",
  "relative_time.full.days": "{number, plural, other {# 天}}前",
  "relative_time.full.hours": "{number, plural, other {# 小时}}前",
  "relative_time.full.just_now": "刚刚",
  "relative_time.full.minutes": "{number, plural, other {# 分钟}}前",
  "relative_time.full.seconds": "{number, plural, other {# 秒}}前",
  "relative_time.hours": "{number}小时",
  "relative_time.just_now": "刚才",
  "relative_time.minutes": "{number}分钟",
  "relative_time.seconds": "{number}秒",
  "relative_time.today": "今天",
  "remove_quote_hint.button_label": "明白了",
  "remove_quote_hint.message": "你可以通过 {icon} 选项菜单进行此操作。",
  "remove_quote_hint.title": "是否希望删除你的引用贴文？",
  "reply_indicator.attachments": "{count, plural, other {# 个附件}}",
  "reply_indicator.cancel": "取消",
  "reply_indicator.poll": "投票",
  "report.block": "屏蔽",
  "report.block_explanation": "你将不再看到对方的贴文。对方也将无法看到你的贴文或关注你。对方将能够知晓自己被屏蔽。",
  "report.categories.legal": "违法内容",
  "report.categories.other": "其它",
  "report.categories.spam": "垃圾信息",
  "report.categories.violation": "内容违反一条或多条站点规则",
  "report.category.subtitle": "选择最合适的选项",
  "report.category.title_account": "告诉我们此账户有什么问题",
  "report.category.title_collection": "告诉我们此合集有什么问题",
  "report.category.title_status": "告诉我们此贴文有什么问题",
  "report.close": "完成",
  "report.comment.title": "你还有其它信息需要我们知晓吗？",
  "report.forward": "转发至 {target}",
  "report.forward_hint": "该账户来自另一站点。要将举报副本也匿名发送到那边吗？",
  "report.mute": "隐藏",
  "report.mute_explanation": "你将不会看到对方的贴文。对方仍然可以关注你并看到你的贴文，但不会知道自己已被隐藏。",
  "report.next": "下一个",
  "report.placeholder": "补充评论",
  "report.reasons.dislike": "我不喜欢",
  "report.reasons.dislike_description": "这不是你想看到的内容",
  "report.reasons.legal": "这是违法内容",
  "report.reasons.legal_description": "你认为它违反了你所在地区或站点所在地区的法律",
  "report.reasons.other": "其它原因",
  "report.reasons.other_description": "问题不属于其它任何类别",
  "report.reasons.spam": "这是垃圾信息",
  "report.reasons.spam_description": "恶意链接、虚假互动或重复回复",
  "report.reasons.violation": "这违反了站点规则",
  "report.reasons.violation_description": "你发现它违反了特定规则",
  "report.rules.subtitle": "选择所有适用的选项",
  "report.rules.title": "违反了哪些规则？",
  "report.statuses.subtitle": "选择所有适用的选项",
  "report.statuses.title": "是否有能够支持这个举报的贴文？",
  "report.submission_error": "无法提交举报",
  "report.submission_error_details": "请检查你的网络连接，稍后再试。",
  "report.submit": "提交",
  "report.target": "举报 {target}",
  "report.thanks.take_action": "以下是可以控制你在 Mastodon 上看到的内容的选项：",
  "report.thanks.take_action_actionable": "我们审核此内容时，你可以对 @{name} 采取措施：",
  "report.thanks.title": "不想看到这个吗？",
  "report.thanks.title_actionable": "感谢举报，我们会进行核查。",
  "report.unfollow": "取关 @{name}",
  "report.unfollow_explanation": "你正在关注此账户。如需停止在你的主页时间线中看到其贴文，请取消关注。",
  "report_notification.attached_statuses": "附 {count, plural, other {{count} 条贴文}}",
  "report_notification.categories.legal": "违法内容",
  "report_notification.categories.legal_sentence": "非法内容",
  "report_notification.categories.other": "其它",
  "report_notification.categories.other_sentence": "其它",
  "report_notification.categories.spam": "垃圾信息",
  "report_notification.categories.spam_sentence": "垃圾信息",
  "report_notification.categories.violation": "违反规则",
  "report_notification.categories.violation_sentence": "违反规则",
  "report_notification.open": "查看举报",
  "search.clear": "清除搜索",
  "search.no_recent_searches": "无最近搜索",
  "search.placeholder": "搜索",
  "search.quick_action.account_search": "包含 {x} 的账户",
  "search.quick_action.go_to_account": "前往 {x} 的账户",
  "search.quick_action.go_to_hashtag": "前往话题 {x}",
  "search.quick_action.open_url": "在 Mastodon 中打开 URL",
  "search.quick_action.status_search": "包含 {x} 的贴文",
  "search.search_or_paste": "搜索或粘贴 URL",
  "search_popout.full_text_search_disabled_message": "在 {domain} 上不可用。",
  "search_popout.full_text_search_logged_out_message": "仅在登录后可用。",
  "search_popout.language_code": "ISO 语言代码",
  "search_popout.options": "搜索选项",
  "search_popout.quick_actions": "快捷操作",
  "search_popout.recent": "最近搜索",
  "search_popout.specific_date": "特定日期",
  "search_popout.user": "用户",
  "search_results.accounts": "账户",
  "search_results.all": "全部",
  "search_results.collections": "合集",
  "search_results.hashtags": "话题",
  "search_results.no_results": "无结果。",
  "search_results.no_search_yet": "尝试搜索贴文、账户或话题。",
  "search_results.see_all": "查看全部",
  "search_results.statuses": "贴文",
  "search_results.title": "搜索“{q}”",
  "server_banner.about_active_users": "过去 30 天内使用此站点的用户（月活跃用户）",
  "server_banner.active_users": "活跃用户",
  "server_banner.administered_by": "管理员：",
  "server_banner.create_account": "创建账户",
  "server_banner.is_one_of_many": "{domain} 是众多独立的 Mastodon 站点之一，你可以通过它加入联邦宇宙。",
  "server_banner.log_in": "登录",
  "server_banner.more_about_this_server": "了解更多关于本站点的信息",
  "server_banner.server_stats": "站点统计数据：",
  "sign_in_banner.create_account": "创建账户",
  "sign_in_banner.follow_anyone": "关注联邦宇宙中的任何人，并按时间顺序查看所有内容。没有算法、广告和点击诱饵。",
  "sign_in_banner.mastodon_is": "Mastodon 是了解最新动态的最佳方式。",
  "sign_in_banner.sign_in": "登录",
  "sign_in_banner.sso_redirect": "登录或注册",
  "skip_links.hotkey": "<span>快捷键</span> {hotkey}",
  "skip_links.skip_to_content": "跳转到主要内容",
  "skip_links.skip_to_navigation": "跳转到主菜单",
  "status.admin_account": "打开 @{name} 的管理界面",
  "status.admin_domain": "打开 {domain} 的管理界面",
  "status.admin_status": "在管理界面中打开此贴文",
  "status.all_disabled": "已禁止转发与引用",
  "status.block": "屏蔽 @{name}",
  "status.bookmark": "收藏",
  "status.cancel_reblog_private": "取消转发",
  "status.cannot_edit": "你无权编辑此贴文",
  "status.cannot_quote": "你无权引用这条贴文",
  "status.cannot_reblog": "此贴文无法被转发",
  "status.contains_quote": "包含引用",
  "status.context.loading": "正在加载更多回复",
  "status.context.loading_error": "无法加载新回复",
  "status.context.loading_success": "已加载新回复",
  "status.context.more_replies_found": "发现更多回复",
  "status.context.retry": "重试",
  "status.context.show": "查看",
  "status.continued_thread": "接续贴文串",
  "status.copy": "复制贴文链接",
  "status.delete": "删除",
  "status.delete.success": "贴文已删除",
  "status.detailed_status": "对话详情",
  "status.direct": "私信 @{name}",
  "status.direct_indicator": "私信",
  "status.edit": "编辑",
  "status.edited": "最后编辑于 {date}",
  "status.edited_x_times": "{count, plural, other {已编辑 {count} 次}}",
  "status.embed": "获取嵌入代码",
  "status.favourite": "点赞",
  "status.favourites_count": "{count, plural, other {{counter} 次点赞}}",
  "status.filter": "过滤此贴文",
  "status.history.created": "{name} 创建于 {date}",
  "status.history.edited": "{name} 编辑于 {date}",
  "status.likes_title": "贴文点赞",
  "status.load_more": "加载更多",
  "status.media.open": "点击打开",
  "status.media.show": "点击显示",
  "status.media_hidden": "媒体已被隐藏",
  "status.mention": "提及 @{name}",
  "status.meta": "于 {createdAt} 来自 {source} {sep} {visibility}",
  "status.meta.no_application": "{createdAt} {sep} {visibility}",
  "status.more": "更多",
  "status.mute": "隐藏 @{name}",
  "status.mute_conversation": "静音此对话",
  "status.not_quoted": "你未在此贴文中被引用",
  "status.open": "展开贴文",
  "status.options": "贴文选项",
  "status.pin": "在账户页置顶",
  "status.public_only": "此贴文是私密的",
  "status.quote": "引用",
  "status.quote.cancel": "取消引用",
  "status.quote_error.blocked_account_hint.title": "由于你已屏蔽 @{name}，此贴文已隐藏。",
  "status.quote_error.blocked_domain_hint.title": "由于你已屏蔽 {domain}，此贴文已隐藏。",
  "status.quote_error.filtered": "因命中过滤规则而被隐藏",
  "status.quote_error.limited_account_hint.action": "仍然显示",
  "status.quote_error.limited_account_hint.title": "此账户已被 {domain} 管理员隐藏。",
  "status.quote_error.muted_account_hint.title": "由于你已设置隐藏@{name}，此贴文已隐藏。",
  "status.quote_error.not_available": "贴文不可用",
  "status.quote_error.pending_approval": "贴文待批准",
  "status.quote_error.pending_approval_popout.body": "在 Mastodon，你可以控制其他人引用你贴文的权限。此贴文将在获得原作者同意后发布。",
  "status.quote_error.revoked": "贴文已被作者删除",
  "status.quote_followers_only": "只有粉丝才能引用此贴文",
  "status.quote_manual_review": "贴文作者将手动审核",
  "status.quote_noun": "引用",
  "status.quote_policy_change": "更改引用范围",
  "status.quote_post_author": "引用了 @{name} 的贴文",
  "status.quote_private": "不能引用非公开贴文",
  "status.quotes.empty": "还没有人引用过此条贴文。引用了此贴文的账户会显示在这里。",
  "status.quotes.local_other_disclaimer": "被作者拒绝的引用将不会显示。",
  "status.quotes.remote_other_disclaimer": "此处仅保证会显示来自 {domain} 的引用。被作者拒绝的引用将不会显示。",
  "status.quotes_count": "{count, plural, other {{counter} 次引用}}",
  "status.read_more": "阅读更多",
  "status.reblog": "转发",
  "status.reblog_or_quote": "转发或引用",
  "status.reblog_private": "向粉丝再次分享",
  "status.reblogged_by": "{name} 转发了",
  "status.reblogs.empty": "还没有人转发这条贴文。当有人转发时，转发者会显示在这里。",
  "status.reblogs_count": "{count, plural, other {{counter} 次转发}}",
  "status.redraft": "删除并重新编辑",
  "status.remove_bookmark": "取消收藏",
  "status.remove_favourite": "取消点赞",
  "status.remove_quote": "移除",
  "status.replied_in_thread": "已在贴文串中回复",
  "status.replied_to": "回复 {name}",
  "status.reply": "回复",
  "status.replyAll": "回复贴文串",
  "status.report": "举报 @{name}",
  "status.request_quote": "请求引用",
  "status.revoke_quote": "将我的贴文从 @{name} 的贴文中移除",
  "status.sensitive_warning": "敏感内容",
  "status.share": "分享",
  "status.show_less_all": "全部折叠",
  "status.show_more_all": "全部展开",
  "status.show_original": "显示原文",
  "status.title": "{name} 的贴文",
  "status.title.with_attachments": "{user} 发布了 {attachmentCount, plural, other {{attachmentCount} 个媒体附件}}",
  "status.translate": "翻译",
  "status.translated_from_with": "由 {provider} 从 {lang} 翻译",
  "status.uncached_media_warning": "无法预览",
  "status.unmute_conversation": "取消静音对话",
  "status.unpin": "从账户页取消置顶",
  "subscribed_languages.lead": "更改后，只有所选语言的贴文才会出现在你的主页和列表时间线上。不选择任何语言即可接收所有语言的贴文。",
  "subscribed_languages.save": "保存更改",
  "subscribed_languages.target": "更改 {target} 的订阅语言",
  "tab_bar.messages": "私信",
  "tabs_bar.account_settings": "账户设置",
  "tabs_bar.create_custom_feed": "创建",
  "tabs_bar.custom_feeds": "自定义时间线",
  "tabs_bar.custom_feeds_empty": "你还没有自定义时间线。",
  "tabs_bar.explore": "探索",
  "tabs_bar.fediverse_feeds": "Fediverse 动态",
  "tabs_bar.followed_hashtags": "关注的话题",
  "tabs_bar.followed_tags_view_all": "查看全部",
  "tabs_bar.home": "主页",
  "tabs_bar.menu": "菜单",
  "tabs_bar.messages": "私信",
  "tabs_bar.notifications": "通知",
  "tabs_bar.publish": "发布",
  "tabs_bar.quick_links": "快捷链接",
  "tabs_bar.saved": "已保存",
  "tabs_bar.search": "搜索",
  "tabs_bar.settings": "设置",
  "tag.remove": "移除",
  "terms_of_service.effective_as_of": "于 {date} 生效",
  "terms_of_service.title": "服务条款",
  "terms_of_service.upcoming_changes_on": "将于 {date} 生效的变更",
  "time_remaining.days": "{number, plural, other {剩余 {number} 天}}",
  "time_remaining.hours": "{number, plural, other {剩余 {number} 小时}}",
  "time_remaining.minutes": "{number, plural, other {剩余 {number} 分钟}}",
  "time_remaining.moments": "即将结束",
  "time_remaining.seconds": "{number, plural, other {剩余 {number} 秒}}",
  "trends.counter_by_accounts": "在过去 {days, plural, other {{days} 天}}内有 {count, plural, other {{counter} 人}}",
  "trends.trending_now": "当前热门",
  "ui.beforeunload": "如果你离开 Mastodon，你的草稿将会丢失。",
  "units.short.billion": "{count}十亿",
  "units.short.million": "{count}百万",
  "units.short.thousand": "{count}千",
  "upload_area.title": "拖拽文件至此上传",
  "upload_button.label": "添加图片、视频或音频文件",
  "upload_error.limit": "文件上传数量已达上限。",
  "upload_error.poll": "不允许在发起投票的同时上传文件。",
  "upload_error.quote": "引用时不允许上传文件。",
  "upload_form.drag_and_drop.instructions": "按空格键或回车键选中媒体附件。拖动时，可使用方向键向任意方向移动媒体附件。再次按下空格键或回车键可将其放置到新位置，或按 Esc 取消。",
  "upload_form.drag_and_drop.on_drag_cancel": "拖动已取消。媒体附件 {item} 已取消上传。",
  "upload_form.drag_and_drop.on_drag_end": "媒体附件 {item} 已取消上传。",
  "upload_form.drag_and_drop.on_drag_over": "媒体附件 {item} 已移动。",
  "upload_form.drag_and_drop.on_drag_start": "已选中媒体附件 {item}。",
  "upload_form.edit": "编辑",
  "upload_progress.label": "上传中……",
  "upload_progress.processing": "处理中…",
  "username.taken": "该用户名已被占用。请换一个",
  "video.close": "关闭视频",
  "video.download": "下载文件",
  "video.exit_fullscreen": "退出全屏",
  "video.expand": "展开视频",
  "video.fullscreen": "全屏",
  "video.hide": "隐藏视频",
  "video.mute": "静音",
  "video.pause": "暂停",
  "video.play": "播放",
  "video.skip_backward": "后退",
  "video.skip_forward": "前进",
  "video.unmute": "取消静音",
  "video.volume_down": "调低音量",
  "video.volume_up": "调高音量",
  "visibility_modal.button_title": "设置可见性",
  "visibility_modal.direct_quote_warning.text": "如果你保存当前设置，嵌入的引用将转换为链接。",
  "visibility_modal.direct_quote_warning.title": "私信中无法嵌入引用",
  "visibility_modal.header": "可见性与互动规则",
  "visibility_modal.helper.direct_quoting": "在 Mastodon 发布的私信无法被他人引用。",
  "visibility_modal.helper.privacy_editing": "贴文发布后便无法更改可见性。",
  "visibility_modal.helper.privacy_private_self_quote": "引用自己的私密贴文时，可见性无法设置为公开。",
  "visibility_modal.helper.private_quoting": "在 Mastodon 发布的仅粉丝可见贴文无法被他人引用。",
  "visibility_modal.helper.unlisted_quoting": "当其他人引用你的贴文时，他们的贴文不会出现在热门时间线上。",
  "visibility_modal.instructions": "控制谁可以和此贴文互动。你也可以前往<link>偏好设置 > 贴文默认设置</link>将此设置应用到所有未来发布的贴文。",
  "visibility_modal.privacy_label": "可见性",
  "visibility_modal.quote_followers": "仅粉丝",
  "visibility_modal.quote_label": "谁可以引用",
  "visibility_modal.quote_nobody": "仅自己",
  "visibility_modal.quote_public": "任何人",
  "visibility_modal.save": "保存"
}
